/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StammdatenIndexRouteImport } from './routes/stammdaten/index'
import { Route as AuswahlfelderIndexRouteImport } from './routes/auswahlfelder/index'
import { Route as VorgaengeNeuRouteImport } from './routes/vorgaenge/neu'
import { Route as VorgaengeDossierIdRouteImport } from './routes/vorgaenge/$dossierId'
import { Route as AuswahlfelderNeuRouteImport } from './routes/auswahlfelder/neu'
import { Route as AuswahlfelderChoiceIdRouteImport } from './routes/auswahlfelder/$choiceId'
import { Route as VerwaltungMigrationsfehlerIndexRouteImport } from './routes/verwaltung/migrationsfehler/index'
import { Route as VerwaltungGruppenIndexRouteImport } from './routes/verwaltung/gruppen/index'
import { Route as VerwaltungBenutzerIndexRouteImport } from './routes/verwaltung/benutzer/index'
import { Route as StammdatenVorlagenIndexRouteImport } from './routes/stammdaten/vorlagen/index'
import { Route as StammdatenVerfuegungsvorlagenIndexRouteImport } from './routes/stammdaten/verfuegungsvorlagen/index'
import { Route as StammdatenNebenbestimmungenIndexRouteImport } from './routes/stammdaten/nebenbestimmungen/index'
import { Route as StammdatenLaenderIndexRouteImport } from './routes/stammdaten/laender/index'
import { Route as StammdatenKontakteIndexRouteImport } from './routes/stammdaten/kontakte/index'
import { Route as StammdatenGueterIndexRouteImport } from './routes/stammdaten/gueter/index'
import { Route as StammdatenGebuehrenIndexRouteImport } from './routes/stammdaten/gebuehren/index'
import { Route as StammdatenFirmenIndexRouteImport } from './routes/stammdaten/firmen/index'
import { Route as StammdatenAktenzeichenIndexRouteImport } from './routes/stammdaten/aktenzeichen/index'
import { Route as AuswahlfelderZustaendigkeitenIndexRouteImport } from './routes/auswahlfelder/zustaendigkeiten/index'
import { Route as AuswahlfelderZusaetzlicheMerkmaleIndexRouteImport } from './routes/auswahlfelder/zusaetzliche-merkmale/index'
import { Route as AuswahlfelderWarenlistenIndexRouteImport } from './routes/auswahlfelder/warenlisten/index'
import { Route as AuswahlfelderWarenlistenVorgangIndexRouteImport } from './routes/auswahlfelder/warenlisten-vorgang/index'
import { Route as AuswahlfelderWaehrungenIndexRouteImport } from './routes/auswahlfelder/waehrungen/index'
import { Route as AuswahlfelderWaehrungenWareIndexRouteImport } from './routes/auswahlfelder/waehrungen-ware/index'
import { Route as AuswahlfelderVotenIndexRouteImport } from './routes/auswahlfelder/voten/index'
import { Route as AuswahlfelderVotantenIndexRouteImport } from './routes/auswahlfelder/votanten/index'
import { Route as AuswahlfelderVorgangsartenIndexRouteImport } from './routes/auswahlfelder/vorgangsarten/index'
import { Route as AuswahlfelderUnterstatusIndexRouteImport } from './routes/auswahlfelder/unterstatus/index'
import { Route as AuswahlfelderTransportroutenIndexRouteImport } from './routes/auswahlfelder/transportrouten/index'
import { Route as AuswahlfelderTransportroutenVorgangIndexRouteImport } from './routes/auswahlfelder/transportrouten-vorgang/index'
import { Route as AuswahlfelderTransportmittelIndexRouteImport } from './routes/auswahlfelder/transportmittel/index'
import { Route as AuswahlfelderStatusIndexRouteImport } from './routes/auswahlfelder/status/index'
import { Route as AuswahlfelderSonstigeAntraegeIndexRouteImport } from './routes/auswahlfelder/sonstige-antraege/index'
import { Route as AuswahlfelderRollenIndexRouteImport } from './routes/auswahlfelder/rollen/index'
import { Route as AuswahlfelderRollenBeteiligteIndexRouteImport } from './routes/auswahlfelder/rollen-beteiligte/index'
import { Route as AuswahlfelderRechtsgrundlagenIndexRouteImport } from './routes/auswahlfelder/rechtsgrundlagen/index'
import { Route as AuswahlfelderPruefprogrammeIndexRouteImport } from './routes/auswahlfelder/pruefprogramme/index'
import { Route as AuswahlfelderPrioritaetenIndexRouteImport } from './routes/auswahlfelder/prioritaeten/index'
import { Route as AuswahlfelderLaendergruppenIndexRouteImport } from './routes/auswahlfelder/laendergruppen/index'
import { Route as AuswahlfelderLaendergruppenVorgangIndexRouteImport } from './routes/auswahlfelder/laendergruppen-vorgang/index'
import { Route as AuswahlfelderKennzeichentypenIndexRouteImport } from './routes/auswahlfelder/kennzeichentypen/index'
import { Route as AuswahlfelderKategorienNebenbestimmungenIndexRouteImport } from './routes/auswahlfelder/kategorien-nebenbestimmungen/index'
import { Route as AuswahlfelderKategorienGebuehrenIndexRouteImport } from './routes/auswahlfelder/kategorien-gebuehren/index'
import { Route as AuswahlfelderKassenzeichenIndexRouteImport } from './routes/auswahlfelder/kassenzeichen/index'
import { Route as AuswahlfelderImportExportArtenIndexRouteImport } from './routes/auswahlfelder/import-export-arten/index'
import { Route as AuswahlfelderHaeufigkeitenIndexRouteImport } from './routes/auswahlfelder/haeufigkeiten/index'
import { Route as AuswahlfelderHaeufigkeitenTransportIndexRouteImport } from './routes/auswahlfelder/haeufigkeiten-transport/index'
import { Route as AuswahlfelderGeschaeftsartenIndexRouteImport } from './routes/auswahlfelder/geschaeftsarten/index'
import { Route as AuswahlfelderGenehmigungstatbestaendeIndexRouteImport } from './routes/auswahlfelder/genehmigungstatbestaende/index'
import { Route as AuswahlfelderEntscheidungsebenenIndexRouteImport } from './routes/auswahlfelder/entscheidungsebenen/index'
import { Route as AuswahlfelderDatumstypenIndexRouteImport } from './routes/auswahlfelder/datumstypen/index'
import { Route as AuswahlfelderBranchenIndexRouteImport } from './routes/auswahlfelder/branchen/index'
import { Route as AuswahlfelderBesondereGenehmigungenIndexRouteImport } from './routes/auswahlfelder/besondere-genehmigungen/index'
import { Route as AuswahlfelderBesondereBedingungenIndexRouteImport } from './routes/auswahlfelder/besondere-bedingungen/index'
import { Route as AuswahlfelderBeantragteVerfahrenIndexRouteImport } from './routes/auswahlfelder/beantragte-verfahren/index'
import { Route as AuswahlfelderAntragsartenIndexRouteImport } from './routes/auswahlfelder/antragsarten/index'
import { Route as AuswahlfelderAntragsartenGenehmigungstypenIndexRouteImport } from './routes/auswahlfelder/antragsarten-genehmigungstypen/index'
import { Route as AuswahlfelderAbschlussartenIndexRouteImport } from './routes/auswahlfelder/abschlussarten/index'
import { Route as VorgaengelistenUnsereRouteImport } from './routes/vorgaenge/(listen)/unsere'
import { Route as VorgaengelistenMeineRouteImport } from './routes/vorgaenge/(listen)/meine'
import { Route as VorgaengelistenAlleRouteImport } from './routes/vorgaenge/(listen)/alle'
import { Route as VorgaengeDossierIdBearbeitenRouteImport } from './routes/vorgaenge/$dossierId_.bearbeiten'
import { Route as VerwaltungGruppenNeuRouteImport } from './routes/verwaltung/gruppen/neu'
import { Route as VerwaltungGruppenGroupIdRouteImport } from './routes/verwaltung/gruppen/$groupId'
import { Route as VerwaltungBenutzerNeuRouteImport } from './routes/verwaltung/benutzer/neu'
import { Route as VerwaltungBenutzerUserIdRouteImport } from './routes/verwaltung/benutzer/$userId'
import { Route as StammdatenVerfuegungsvorlagenNeuRouteImport } from './routes/stammdaten/verfuegungsvorlagen/neu'
import { Route as StammdatenVerfuegungsvorlagenLogTemplateIdRouteImport } from './routes/stammdaten/verfuegungsvorlagen/$logTemplateId'
import { Route as StammdatenNebenbestimmungenNeuRouteImport } from './routes/stammdaten/nebenbestimmungen/neu'
import { Route as StammdatenNebenbestimmungenCollateralClauseIdRouteImport } from './routes/stammdaten/nebenbestimmungen/$collateralClauseId'
import { Route as StammdatenLaenderNeuRouteImport } from './routes/stammdaten/laender/neu'
import { Route as StammdatenLaenderCountryIdRouteImport } from './routes/stammdaten/laender/$countryId'
import { Route as StammdatenKontakteNeuRouteImport } from './routes/stammdaten/kontakte/neu'
import { Route as StammdatenKontakteContactIdRouteImport } from './routes/stammdaten/kontakte/$contactId'
import { Route as StammdatenGueterNeuRouteImport } from './routes/stammdaten/gueter/neu'
import { Route as StammdatenGueterGoodIdRouteImport } from './routes/stammdaten/gueter/$goodId'
import { Route as StammdatenGebuehrenNeuRouteImport } from './routes/stammdaten/gebuehren/neu'
import { Route as StammdatenGebuehrenFeeIdRouteImport } from './routes/stammdaten/gebuehren/$feeId'
import { Route as StammdatenFirmenNeuRouteImport } from './routes/stammdaten/firmen/neu'
import { Route as StammdatenFirmenCompanyIdRouteImport } from './routes/stammdaten/firmen/$companyId'
import { Route as StammdatenAktenzeichenNeuRouteImport } from './routes/stammdaten/aktenzeichen/neu'
import { Route as StammdatenAktenzeichenFileNumberIdRouteImport } from './routes/stammdaten/aktenzeichen/$fileNumberId'
import { Route as AuswahlfelderKassenzeichenNeuRouteImport } from './routes/auswahlfelder/kassenzeichen/neu'
import { Route as AuswahlfelderKassenzeichenKassenzeichenIdRouteImport } from './routes/auswahlfelder/kassenzeichen/$kassenzeichenId'
import { Route as AuswahlfelderChoiceIdBearbeitenRouteImport } from './routes/auswahlfelder/$choiceId_.bearbeiten'
import { Route as VerwaltungGruppenGroupIdBearbeitenRouteImport } from './routes/verwaltung/gruppen/$groupId_.bearbeiten'
import { Route as VerwaltungBenutzerUserIdBearbeitenRouteImport } from './routes/verwaltung/benutzer/$userId_.bearbeiten'
import { Route as StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRouteImport } from './routes/stammdaten/verfuegungsvorlagen/$logTemplateId_.bearbeiten'
import { Route as StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRouteImport } from './routes/stammdaten/nebenbestimmungen/$collateralClauseId_.bearbeiten'
import { Route as StammdatenLaenderCountryIdBearbeitenRouteImport } from './routes/stammdaten/laender/$countryId_.bearbeiten'
import { Route as StammdatenKontakteContactIdBearbeitenRouteImport } from './routes/stammdaten/kontakte/$contactId_.bearbeiten'
import { Route as StammdatenGueterGoodIdBearbeitenRouteImport } from './routes/stammdaten/gueter/$goodId_.bearbeiten'
import { Route as StammdatenGebuehrenFeeIdBearbeitenRouteImport } from './routes/stammdaten/gebuehren/$feeId_.bearbeiten'
import { Route as StammdatenFirmenCompanyIdBearbeitenRouteImport } from './routes/stammdaten/firmen/$companyId_.bearbeiten'
import { Route as StammdatenAktenzeichenFileNumberIdBearbeitenRouteImport } from './routes/stammdaten/aktenzeichen/$fileNumberId_.bearbeiten'
import { Route as AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRouteImport } from './routes/auswahlfelder/kassenzeichen/$kassenzeichenId_.bearbeiten'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenIndexRoute = StammdatenIndexRouteImport.update({
  id: '/stammdaten/',
  path: '/stammdaten/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuswahlfelderIndexRoute = AuswahlfelderIndexRouteImport.update({
  id: '/auswahlfelder/',
  path: '/auswahlfelder/',
  getParentRoute: () => rootRouteImport,
} as any)
const VorgaengeNeuRoute = VorgaengeNeuRouteImport.update({
  id: '/vorgaenge/neu',
  path: '/vorgaenge/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const VorgaengeDossierIdRoute = VorgaengeDossierIdRouteImport.update({
  id: '/vorgaenge/$dossierId',
  path: '/vorgaenge/$dossierId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuswahlfelderNeuRoute = AuswahlfelderNeuRouteImport.update({
  id: '/auswahlfelder/neu',
  path: '/auswahlfelder/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const AuswahlfelderChoiceIdRoute = AuswahlfelderChoiceIdRouteImport.update({
  id: '/auswahlfelder/$choiceId',
  path: '/auswahlfelder/$choiceId',
  getParentRoute: () => rootRouteImport,
} as any)
const VerwaltungMigrationsfehlerIndexRoute =
  VerwaltungMigrationsfehlerIndexRouteImport.update({
    id: '/verwaltung/migrationsfehler/',
    path: '/verwaltung/migrationsfehler/',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerwaltungGruppenIndexRoute = VerwaltungGruppenIndexRouteImport.update({
  id: '/verwaltung/gruppen/',
  path: '/verwaltung/gruppen/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerwaltungBenutzerIndexRoute = VerwaltungBenutzerIndexRouteImport.update({
  id: '/verwaltung/benutzer/',
  path: '/verwaltung/benutzer/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenVorlagenIndexRoute = StammdatenVorlagenIndexRouteImport.update({
  id: '/stammdaten/vorlagen/',
  path: '/stammdaten/vorlagen/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenVerfuegungsvorlagenIndexRoute =
  StammdatenVerfuegungsvorlagenIndexRouteImport.update({
    id: '/stammdaten/verfuegungsvorlagen/',
    path: '/stammdaten/verfuegungsvorlagen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenNebenbestimmungenIndexRoute =
  StammdatenNebenbestimmungenIndexRouteImport.update({
    id: '/stammdaten/nebenbestimmungen/',
    path: '/stammdaten/nebenbestimmungen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenLaenderIndexRoute = StammdatenLaenderIndexRouteImport.update({
  id: '/stammdaten/laender/',
  path: '/stammdaten/laender/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenKontakteIndexRoute = StammdatenKontakteIndexRouteImport.update({
  id: '/stammdaten/kontakte/',
  path: '/stammdaten/kontakte/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenGueterIndexRoute = StammdatenGueterIndexRouteImport.update({
  id: '/stammdaten/gueter/',
  path: '/stammdaten/gueter/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenGebuehrenIndexRoute =
  StammdatenGebuehrenIndexRouteImport.update({
    id: '/stammdaten/gebuehren/',
    path: '/stammdaten/gebuehren/',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenFirmenIndexRoute = StammdatenFirmenIndexRouteImport.update({
  id: '/stammdaten/firmen/',
  path: '/stammdaten/firmen/',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenAktenzeichenIndexRoute =
  StammdatenAktenzeichenIndexRouteImport.update({
    id: '/stammdaten/aktenzeichen/',
    path: '/stammdaten/aktenzeichen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderZustaendigkeitenIndexRoute =
  AuswahlfelderZustaendigkeitenIndexRouteImport.update({
    id: '/auswahlfelder/zustaendigkeiten/',
    path: '/auswahlfelder/zustaendigkeiten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderZusaetzlicheMerkmaleIndexRoute =
  AuswahlfelderZusaetzlicheMerkmaleIndexRouteImport.update({
    id: '/auswahlfelder/zusaetzliche-merkmale/',
    path: '/auswahlfelder/zusaetzliche-merkmale/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderWarenlistenIndexRoute =
  AuswahlfelderWarenlistenIndexRouteImport.update({
    id: '/auswahlfelder/warenlisten/',
    path: '/auswahlfelder/warenlisten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderWarenlistenVorgangIndexRoute =
  AuswahlfelderWarenlistenVorgangIndexRouteImport.update({
    id: '/auswahlfelder/warenlisten-vorgang/',
    path: '/auswahlfelder/warenlisten-vorgang/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderWaehrungenIndexRoute =
  AuswahlfelderWaehrungenIndexRouteImport.update({
    id: '/auswahlfelder/waehrungen/',
    path: '/auswahlfelder/waehrungen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderWaehrungenWareIndexRoute =
  AuswahlfelderWaehrungenWareIndexRouteImport.update({
    id: '/auswahlfelder/waehrungen-ware/',
    path: '/auswahlfelder/waehrungen-ware/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderVotenIndexRoute = AuswahlfelderVotenIndexRouteImport.update({
  id: '/auswahlfelder/voten/',
  path: '/auswahlfelder/voten/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuswahlfelderVotantenIndexRoute =
  AuswahlfelderVotantenIndexRouteImport.update({
    id: '/auswahlfelder/votanten/',
    path: '/auswahlfelder/votanten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderVorgangsartenIndexRoute =
  AuswahlfelderVorgangsartenIndexRouteImport.update({
    id: '/auswahlfelder/vorgangsarten/',
    path: '/auswahlfelder/vorgangsarten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderUnterstatusIndexRoute =
  AuswahlfelderUnterstatusIndexRouteImport.update({
    id: '/auswahlfelder/unterstatus/',
    path: '/auswahlfelder/unterstatus/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderTransportroutenIndexRoute =
  AuswahlfelderTransportroutenIndexRouteImport.update({
    id: '/auswahlfelder/transportrouten/',
    path: '/auswahlfelder/transportrouten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderTransportroutenVorgangIndexRoute =
  AuswahlfelderTransportroutenVorgangIndexRouteImport.update({
    id: '/auswahlfelder/transportrouten-vorgang/',
    path: '/auswahlfelder/transportrouten-vorgang/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderTransportmittelIndexRoute =
  AuswahlfelderTransportmittelIndexRouteImport.update({
    id: '/auswahlfelder/transportmittel/',
    path: '/auswahlfelder/transportmittel/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderStatusIndexRoute =
  AuswahlfelderStatusIndexRouteImport.update({
    id: '/auswahlfelder/status/',
    path: '/auswahlfelder/status/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderSonstigeAntraegeIndexRoute =
  AuswahlfelderSonstigeAntraegeIndexRouteImport.update({
    id: '/auswahlfelder/sonstige-antraege/',
    path: '/auswahlfelder/sonstige-antraege/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderRollenIndexRoute =
  AuswahlfelderRollenIndexRouteImport.update({
    id: '/auswahlfelder/rollen/',
    path: '/auswahlfelder/rollen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderRollenBeteiligteIndexRoute =
  AuswahlfelderRollenBeteiligteIndexRouteImport.update({
    id: '/auswahlfelder/rollen-beteiligte/',
    path: '/auswahlfelder/rollen-beteiligte/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderRechtsgrundlagenIndexRoute =
  AuswahlfelderRechtsgrundlagenIndexRouteImport.update({
    id: '/auswahlfelder/rechtsgrundlagen/',
    path: '/auswahlfelder/rechtsgrundlagen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderPruefprogrammeIndexRoute =
  AuswahlfelderPruefprogrammeIndexRouteImport.update({
    id: '/auswahlfelder/pruefprogramme/',
    path: '/auswahlfelder/pruefprogramme/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderPrioritaetenIndexRoute =
  AuswahlfelderPrioritaetenIndexRouteImport.update({
    id: '/auswahlfelder/prioritaeten/',
    path: '/auswahlfelder/prioritaeten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderLaendergruppenIndexRoute =
  AuswahlfelderLaendergruppenIndexRouteImport.update({
    id: '/auswahlfelder/laendergruppen/',
    path: '/auswahlfelder/laendergruppen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderLaendergruppenVorgangIndexRoute =
  AuswahlfelderLaendergruppenVorgangIndexRouteImport.update({
    id: '/auswahlfelder/laendergruppen-vorgang/',
    path: '/auswahlfelder/laendergruppen-vorgang/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKennzeichentypenIndexRoute =
  AuswahlfelderKennzeichentypenIndexRouteImport.update({
    id: '/auswahlfelder/kennzeichentypen/',
    path: '/auswahlfelder/kennzeichentypen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKategorienNebenbestimmungenIndexRoute =
  AuswahlfelderKategorienNebenbestimmungenIndexRouteImport.update({
    id: '/auswahlfelder/kategorien-nebenbestimmungen/',
    path: '/auswahlfelder/kategorien-nebenbestimmungen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKategorienGebuehrenIndexRoute =
  AuswahlfelderKategorienGebuehrenIndexRouteImport.update({
    id: '/auswahlfelder/kategorien-gebuehren/',
    path: '/auswahlfelder/kategorien-gebuehren/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKassenzeichenIndexRoute =
  AuswahlfelderKassenzeichenIndexRouteImport.update({
    id: '/auswahlfelder/kassenzeichen/',
    path: '/auswahlfelder/kassenzeichen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderImportExportArtenIndexRoute =
  AuswahlfelderImportExportArtenIndexRouteImport.update({
    id: '/auswahlfelder/import-export-arten/',
    path: '/auswahlfelder/import-export-arten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderHaeufigkeitenIndexRoute =
  AuswahlfelderHaeufigkeitenIndexRouteImport.update({
    id: '/auswahlfelder/haeufigkeiten/',
    path: '/auswahlfelder/haeufigkeiten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderHaeufigkeitenTransportIndexRoute =
  AuswahlfelderHaeufigkeitenTransportIndexRouteImport.update({
    id: '/auswahlfelder/haeufigkeiten-transport/',
    path: '/auswahlfelder/haeufigkeiten-transport/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderGeschaeftsartenIndexRoute =
  AuswahlfelderGeschaeftsartenIndexRouteImport.update({
    id: '/auswahlfelder/geschaeftsarten/',
    path: '/auswahlfelder/geschaeftsarten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderGenehmigungstatbestaendeIndexRoute =
  AuswahlfelderGenehmigungstatbestaendeIndexRouteImport.update({
    id: '/auswahlfelder/genehmigungstatbestaende/',
    path: '/auswahlfelder/genehmigungstatbestaende/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderEntscheidungsebenenIndexRoute =
  AuswahlfelderEntscheidungsebenenIndexRouteImport.update({
    id: '/auswahlfelder/entscheidungsebenen/',
    path: '/auswahlfelder/entscheidungsebenen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderDatumstypenIndexRoute =
  AuswahlfelderDatumstypenIndexRouteImport.update({
    id: '/auswahlfelder/datumstypen/',
    path: '/auswahlfelder/datumstypen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderBranchenIndexRoute =
  AuswahlfelderBranchenIndexRouteImport.update({
    id: '/auswahlfelder/branchen/',
    path: '/auswahlfelder/branchen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderBesondereGenehmigungenIndexRoute =
  AuswahlfelderBesondereGenehmigungenIndexRouteImport.update({
    id: '/auswahlfelder/besondere-genehmigungen/',
    path: '/auswahlfelder/besondere-genehmigungen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderBesondereBedingungenIndexRoute =
  AuswahlfelderBesondereBedingungenIndexRouteImport.update({
    id: '/auswahlfelder/besondere-bedingungen/',
    path: '/auswahlfelder/besondere-bedingungen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderBeantragteVerfahrenIndexRoute =
  AuswahlfelderBeantragteVerfahrenIndexRouteImport.update({
    id: '/auswahlfelder/beantragte-verfahren/',
    path: '/auswahlfelder/beantragte-verfahren/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderAntragsartenIndexRoute =
  AuswahlfelderAntragsartenIndexRouteImport.update({
    id: '/auswahlfelder/antragsarten/',
    path: '/auswahlfelder/antragsarten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderAntragsartenGenehmigungstypenIndexRoute =
  AuswahlfelderAntragsartenGenehmigungstypenIndexRouteImport.update({
    id: '/auswahlfelder/antragsarten-genehmigungstypen/',
    path: '/auswahlfelder/antragsarten-genehmigungstypen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderAbschlussartenIndexRoute =
  AuswahlfelderAbschlussartenIndexRouteImport.update({
    id: '/auswahlfelder/abschlussarten/',
    path: '/auswahlfelder/abschlussarten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const VorgaengelistenUnsereRoute = VorgaengelistenUnsereRouteImport.update({
  id: '/vorgaenge/(listen)/unsere',
  path: '/vorgaenge/unsere',
  getParentRoute: () => rootRouteImport,
} as any)
const VorgaengelistenMeineRoute = VorgaengelistenMeineRouteImport.update({
  id: '/vorgaenge/(listen)/meine',
  path: '/vorgaenge/meine',
  getParentRoute: () => rootRouteImport,
} as any)
const VorgaengelistenAlleRoute = VorgaengelistenAlleRouteImport.update({
  id: '/vorgaenge/(listen)/alle',
  path: '/vorgaenge/alle',
  getParentRoute: () => rootRouteImport,
} as any)
const VorgaengeDossierIdBearbeitenRoute =
  VorgaengeDossierIdBearbeitenRouteImport.update({
    id: '/vorgaenge/$dossierId_/bearbeiten',
    path: '/vorgaenge/$dossierId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerwaltungGruppenNeuRoute = VerwaltungGruppenNeuRouteImport.update({
  id: '/verwaltung/gruppen/neu',
  path: '/verwaltung/gruppen/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const VerwaltungGruppenGroupIdRoute =
  VerwaltungGruppenGroupIdRouteImport.update({
    id: '/verwaltung/gruppen/$groupId',
    path: '/verwaltung/gruppen/$groupId',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerwaltungBenutzerNeuRoute = VerwaltungBenutzerNeuRouteImport.update({
  id: '/verwaltung/benutzer/neu',
  path: '/verwaltung/benutzer/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const VerwaltungBenutzerUserIdRoute =
  VerwaltungBenutzerUserIdRouteImport.update({
    id: '/verwaltung/benutzer/$userId',
    path: '/verwaltung/benutzer/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenVerfuegungsvorlagenNeuRoute =
  StammdatenVerfuegungsvorlagenNeuRouteImport.update({
    id: '/stammdaten/verfuegungsvorlagen/neu',
    path: '/stammdaten/verfuegungsvorlagen/neu',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenVerfuegungsvorlagenLogTemplateIdRoute =
  StammdatenVerfuegungsvorlagenLogTemplateIdRouteImport.update({
    id: '/stammdaten/verfuegungsvorlagen/$logTemplateId',
    path: '/stammdaten/verfuegungsvorlagen/$logTemplateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenNebenbestimmungenNeuRoute =
  StammdatenNebenbestimmungenNeuRouteImport.update({
    id: '/stammdaten/nebenbestimmungen/neu',
    path: '/stammdaten/nebenbestimmungen/neu',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenNebenbestimmungenCollateralClauseIdRoute =
  StammdatenNebenbestimmungenCollateralClauseIdRouteImport.update({
    id: '/stammdaten/nebenbestimmungen/$collateralClauseId',
    path: '/stammdaten/nebenbestimmungen/$collateralClauseId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenLaenderNeuRoute = StammdatenLaenderNeuRouteImport.update({
  id: '/stammdaten/laender/neu',
  path: '/stammdaten/laender/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenLaenderCountryIdRoute =
  StammdatenLaenderCountryIdRouteImport.update({
    id: '/stammdaten/laender/$countryId',
    path: '/stammdaten/laender/$countryId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenKontakteNeuRoute = StammdatenKontakteNeuRouteImport.update({
  id: '/stammdaten/kontakte/neu',
  path: '/stammdaten/kontakte/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenKontakteContactIdRoute =
  StammdatenKontakteContactIdRouteImport.update({
    id: '/stammdaten/kontakte/$contactId',
    path: '/stammdaten/kontakte/$contactId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenGueterNeuRoute = StammdatenGueterNeuRouteImport.update({
  id: '/stammdaten/gueter/neu',
  path: '/stammdaten/gueter/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenGueterGoodIdRoute = StammdatenGueterGoodIdRouteImport.update({
  id: '/stammdaten/gueter/$goodId',
  path: '/stammdaten/gueter/$goodId',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenGebuehrenNeuRoute = StammdatenGebuehrenNeuRouteImport.update({
  id: '/stammdaten/gebuehren/neu',
  path: '/stammdaten/gebuehren/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenGebuehrenFeeIdRoute =
  StammdatenGebuehrenFeeIdRouteImport.update({
    id: '/stammdaten/gebuehren/$feeId',
    path: '/stammdaten/gebuehren/$feeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenFirmenNeuRoute = StammdatenFirmenNeuRouteImport.update({
  id: '/stammdaten/firmen/neu',
  path: '/stammdaten/firmen/neu',
  getParentRoute: () => rootRouteImport,
} as any)
const StammdatenFirmenCompanyIdRoute =
  StammdatenFirmenCompanyIdRouteImport.update({
    id: '/stammdaten/firmen/$companyId',
    path: '/stammdaten/firmen/$companyId',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenAktenzeichenNeuRoute =
  StammdatenAktenzeichenNeuRouteImport.update({
    id: '/stammdaten/aktenzeichen/neu',
    path: '/stammdaten/aktenzeichen/neu',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenAktenzeichenFileNumberIdRoute =
  StammdatenAktenzeichenFileNumberIdRouteImport.update({
    id: '/stammdaten/aktenzeichen/$fileNumberId',
    path: '/stammdaten/aktenzeichen/$fileNumberId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKassenzeichenNeuRoute =
  AuswahlfelderKassenzeichenNeuRouteImport.update({
    id: '/auswahlfelder/kassenzeichen/neu',
    path: '/auswahlfelder/kassenzeichen/neu',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKassenzeichenKassenzeichenIdRoute =
  AuswahlfelderKassenzeichenKassenzeichenIdRouteImport.update({
    id: '/auswahlfelder/kassenzeichen/$kassenzeichenId',
    path: '/auswahlfelder/kassenzeichen/$kassenzeichenId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderChoiceIdBearbeitenRoute =
  AuswahlfelderChoiceIdBearbeitenRouteImport.update({
    id: '/auswahlfelder/$choiceId_/bearbeiten',
    path: '/auswahlfelder/$choiceId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerwaltungGruppenGroupIdBearbeitenRoute =
  VerwaltungGruppenGroupIdBearbeitenRouteImport.update({
    id: '/verwaltung/gruppen/$groupId_/bearbeiten',
    path: '/verwaltung/gruppen/$groupId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerwaltungBenutzerUserIdBearbeitenRoute =
  VerwaltungBenutzerUserIdBearbeitenRouteImport.update({
    id: '/verwaltung/benutzer/$userId_/bearbeiten',
    path: '/verwaltung/benutzer/$userId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute =
  StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRouteImport.update({
    id: '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten',
    path: '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute =
  StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRouteImport.update({
    id: '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten',
    path: '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenLaenderCountryIdBearbeitenRoute =
  StammdatenLaenderCountryIdBearbeitenRouteImport.update({
    id: '/stammdaten/laender/$countryId_/bearbeiten',
    path: '/stammdaten/laender/$countryId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenKontakteContactIdBearbeitenRoute =
  StammdatenKontakteContactIdBearbeitenRouteImport.update({
    id: '/stammdaten/kontakte/$contactId_/bearbeiten',
    path: '/stammdaten/kontakte/$contactId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenGueterGoodIdBearbeitenRoute =
  StammdatenGueterGoodIdBearbeitenRouteImport.update({
    id: '/stammdaten/gueter/$goodId_/bearbeiten',
    path: '/stammdaten/gueter/$goodId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenGebuehrenFeeIdBearbeitenRoute =
  StammdatenGebuehrenFeeIdBearbeitenRouteImport.update({
    id: '/stammdaten/gebuehren/$feeId_/bearbeiten',
    path: '/stammdaten/gebuehren/$feeId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenFirmenCompanyIdBearbeitenRoute =
  StammdatenFirmenCompanyIdBearbeitenRouteImport.update({
    id: '/stammdaten/firmen/$companyId_/bearbeiten',
    path: '/stammdaten/firmen/$companyId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const StammdatenAktenzeichenFileNumberIdBearbeitenRoute =
  StammdatenAktenzeichenFileNumberIdBearbeitenRouteImport.update({
    id: '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten',
    path: '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute =
  AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRouteImport.update({
    id: '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten',
    path: '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auswahlfelder/$choiceId': typeof AuswahlfelderChoiceIdRoute
  '/auswahlfelder/neu': typeof AuswahlfelderNeuRoute
  '/vorgaenge/$dossierId': typeof VorgaengeDossierIdRoute
  '/vorgaenge/neu': typeof VorgaengeNeuRoute
  '/auswahlfelder/': typeof AuswahlfelderIndexRoute
  '/stammdaten/': typeof StammdatenIndexRoute
  '/auswahlfelder/$choiceId/bearbeiten': typeof AuswahlfelderChoiceIdBearbeitenRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId': typeof AuswahlfelderKassenzeichenKassenzeichenIdRoute
  '/auswahlfelder/kassenzeichen/neu': typeof AuswahlfelderKassenzeichenNeuRoute
  '/stammdaten/aktenzeichen/$fileNumberId': typeof StammdatenAktenzeichenFileNumberIdRoute
  '/stammdaten/aktenzeichen/neu': typeof StammdatenAktenzeichenNeuRoute
  '/stammdaten/firmen/$companyId': typeof StammdatenFirmenCompanyIdRoute
  '/stammdaten/firmen/neu': typeof StammdatenFirmenNeuRoute
  '/stammdaten/gebuehren/$feeId': typeof StammdatenGebuehrenFeeIdRoute
  '/stammdaten/gebuehren/neu': typeof StammdatenGebuehrenNeuRoute
  '/stammdaten/gueter/$goodId': typeof StammdatenGueterGoodIdRoute
  '/stammdaten/gueter/neu': typeof StammdatenGueterNeuRoute
  '/stammdaten/kontakte/$contactId': typeof StammdatenKontakteContactIdRoute
  '/stammdaten/kontakte/neu': typeof StammdatenKontakteNeuRoute
  '/stammdaten/laender/$countryId': typeof StammdatenLaenderCountryIdRoute
  '/stammdaten/laender/neu': typeof StammdatenLaenderNeuRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId': typeof StammdatenNebenbestimmungenCollateralClauseIdRoute
  '/stammdaten/nebenbestimmungen/neu': typeof StammdatenNebenbestimmungenNeuRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId': typeof StammdatenVerfuegungsvorlagenLogTemplateIdRoute
  '/stammdaten/verfuegungsvorlagen/neu': typeof StammdatenVerfuegungsvorlagenNeuRoute
  '/verwaltung/benutzer/$userId': typeof VerwaltungBenutzerUserIdRoute
  '/verwaltung/benutzer/neu': typeof VerwaltungBenutzerNeuRoute
  '/verwaltung/gruppen/$groupId': typeof VerwaltungGruppenGroupIdRoute
  '/verwaltung/gruppen/neu': typeof VerwaltungGruppenNeuRoute
  '/vorgaenge/$dossierId/bearbeiten': typeof VorgaengeDossierIdBearbeitenRoute
  '/vorgaenge/alle': typeof VorgaengelistenAlleRoute
  '/vorgaenge/meine': typeof VorgaengelistenMeineRoute
  '/vorgaenge/unsere': typeof VorgaengelistenUnsereRoute
  '/auswahlfelder/abschlussarten/': typeof AuswahlfelderAbschlussartenIndexRoute
  '/auswahlfelder/antragsarten-genehmigungstypen/': typeof AuswahlfelderAntragsartenGenehmigungstypenIndexRoute
  '/auswahlfelder/antragsarten/': typeof AuswahlfelderAntragsartenIndexRoute
  '/auswahlfelder/beantragte-verfahren/': typeof AuswahlfelderBeantragteVerfahrenIndexRoute
  '/auswahlfelder/besondere-bedingungen/': typeof AuswahlfelderBesondereBedingungenIndexRoute
  '/auswahlfelder/besondere-genehmigungen/': typeof AuswahlfelderBesondereGenehmigungenIndexRoute
  '/auswahlfelder/branchen/': typeof AuswahlfelderBranchenIndexRoute
  '/auswahlfelder/datumstypen/': typeof AuswahlfelderDatumstypenIndexRoute
  '/auswahlfelder/entscheidungsebenen/': typeof AuswahlfelderEntscheidungsebenenIndexRoute
  '/auswahlfelder/genehmigungstatbestaende/': typeof AuswahlfelderGenehmigungstatbestaendeIndexRoute
  '/auswahlfelder/geschaeftsarten/': typeof AuswahlfelderGeschaeftsartenIndexRoute
  '/auswahlfelder/haeufigkeiten-transport/': typeof AuswahlfelderHaeufigkeitenTransportIndexRoute
  '/auswahlfelder/haeufigkeiten/': typeof AuswahlfelderHaeufigkeitenIndexRoute
  '/auswahlfelder/import-export-arten/': typeof AuswahlfelderImportExportArtenIndexRoute
  '/auswahlfelder/kassenzeichen/': typeof AuswahlfelderKassenzeichenIndexRoute
  '/auswahlfelder/kategorien-gebuehren/': typeof AuswahlfelderKategorienGebuehrenIndexRoute
  '/auswahlfelder/kategorien-nebenbestimmungen/': typeof AuswahlfelderKategorienNebenbestimmungenIndexRoute
  '/auswahlfelder/kennzeichentypen/': typeof AuswahlfelderKennzeichentypenIndexRoute
  '/auswahlfelder/laendergruppen-vorgang/': typeof AuswahlfelderLaendergruppenVorgangIndexRoute
  '/auswahlfelder/laendergruppen/': typeof AuswahlfelderLaendergruppenIndexRoute
  '/auswahlfelder/prioritaeten/': typeof AuswahlfelderPrioritaetenIndexRoute
  '/auswahlfelder/pruefprogramme/': typeof AuswahlfelderPruefprogrammeIndexRoute
  '/auswahlfelder/rechtsgrundlagen/': typeof AuswahlfelderRechtsgrundlagenIndexRoute
  '/auswahlfelder/rollen-beteiligte/': typeof AuswahlfelderRollenBeteiligteIndexRoute
  '/auswahlfelder/rollen/': typeof AuswahlfelderRollenIndexRoute
  '/auswahlfelder/sonstige-antraege/': typeof AuswahlfelderSonstigeAntraegeIndexRoute
  '/auswahlfelder/status/': typeof AuswahlfelderStatusIndexRoute
  '/auswahlfelder/transportmittel/': typeof AuswahlfelderTransportmittelIndexRoute
  '/auswahlfelder/transportrouten-vorgang/': typeof AuswahlfelderTransportroutenVorgangIndexRoute
  '/auswahlfelder/transportrouten/': typeof AuswahlfelderTransportroutenIndexRoute
  '/auswahlfelder/unterstatus/': typeof AuswahlfelderUnterstatusIndexRoute
  '/auswahlfelder/vorgangsarten/': typeof AuswahlfelderVorgangsartenIndexRoute
  '/auswahlfelder/votanten/': typeof AuswahlfelderVotantenIndexRoute
  '/auswahlfelder/voten/': typeof AuswahlfelderVotenIndexRoute
  '/auswahlfelder/waehrungen-ware/': typeof AuswahlfelderWaehrungenWareIndexRoute
  '/auswahlfelder/waehrungen/': typeof AuswahlfelderWaehrungenIndexRoute
  '/auswahlfelder/warenlisten-vorgang/': typeof AuswahlfelderWarenlistenVorgangIndexRoute
  '/auswahlfelder/warenlisten/': typeof AuswahlfelderWarenlistenIndexRoute
  '/auswahlfelder/zusaetzliche-merkmale/': typeof AuswahlfelderZusaetzlicheMerkmaleIndexRoute
  '/auswahlfelder/zustaendigkeiten/': typeof AuswahlfelderZustaendigkeitenIndexRoute
  '/stammdaten/aktenzeichen/': typeof StammdatenAktenzeichenIndexRoute
  '/stammdaten/firmen/': typeof StammdatenFirmenIndexRoute
  '/stammdaten/gebuehren/': typeof StammdatenGebuehrenIndexRoute
  '/stammdaten/gueter/': typeof StammdatenGueterIndexRoute
  '/stammdaten/kontakte/': typeof StammdatenKontakteIndexRoute
  '/stammdaten/laender/': typeof StammdatenLaenderIndexRoute
  '/stammdaten/nebenbestimmungen/': typeof StammdatenNebenbestimmungenIndexRoute
  '/stammdaten/verfuegungsvorlagen/': typeof StammdatenVerfuegungsvorlagenIndexRoute
  '/stammdaten/vorlagen/': typeof StammdatenVorlagenIndexRoute
  '/verwaltung/benutzer/': typeof VerwaltungBenutzerIndexRoute
  '/verwaltung/gruppen/': typeof VerwaltungGruppenIndexRoute
  '/verwaltung/migrationsfehler/': typeof VerwaltungMigrationsfehlerIndexRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten': typeof AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute
  '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten': typeof StammdatenAktenzeichenFileNumberIdBearbeitenRoute
  '/stammdaten/firmen/$companyId/bearbeiten': typeof StammdatenFirmenCompanyIdBearbeitenRoute
  '/stammdaten/gebuehren/$feeId/bearbeiten': typeof StammdatenGebuehrenFeeIdBearbeitenRoute
  '/stammdaten/gueter/$goodId/bearbeiten': typeof StammdatenGueterGoodIdBearbeitenRoute
  '/stammdaten/kontakte/$contactId/bearbeiten': typeof StammdatenKontakteContactIdBearbeitenRoute
  '/stammdaten/laender/$countryId/bearbeiten': typeof StammdatenLaenderCountryIdBearbeitenRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten': typeof StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten': typeof StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute
  '/verwaltung/benutzer/$userId/bearbeiten': typeof VerwaltungBenutzerUserIdBearbeitenRoute
  '/verwaltung/gruppen/$groupId/bearbeiten': typeof VerwaltungGruppenGroupIdBearbeitenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auswahlfelder/$choiceId': typeof AuswahlfelderChoiceIdRoute
  '/auswahlfelder/neu': typeof AuswahlfelderNeuRoute
  '/vorgaenge/$dossierId': typeof VorgaengeDossierIdRoute
  '/vorgaenge/neu': typeof VorgaengeNeuRoute
  '/auswahlfelder': typeof AuswahlfelderIndexRoute
  '/stammdaten': typeof StammdatenIndexRoute
  '/auswahlfelder/$choiceId/bearbeiten': typeof AuswahlfelderChoiceIdBearbeitenRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId': typeof AuswahlfelderKassenzeichenKassenzeichenIdRoute
  '/auswahlfelder/kassenzeichen/neu': typeof AuswahlfelderKassenzeichenNeuRoute
  '/stammdaten/aktenzeichen/$fileNumberId': typeof StammdatenAktenzeichenFileNumberIdRoute
  '/stammdaten/aktenzeichen/neu': typeof StammdatenAktenzeichenNeuRoute
  '/stammdaten/firmen/$companyId': typeof StammdatenFirmenCompanyIdRoute
  '/stammdaten/firmen/neu': typeof StammdatenFirmenNeuRoute
  '/stammdaten/gebuehren/$feeId': typeof StammdatenGebuehrenFeeIdRoute
  '/stammdaten/gebuehren/neu': typeof StammdatenGebuehrenNeuRoute
  '/stammdaten/gueter/$goodId': typeof StammdatenGueterGoodIdRoute
  '/stammdaten/gueter/neu': typeof StammdatenGueterNeuRoute
  '/stammdaten/kontakte/$contactId': typeof StammdatenKontakteContactIdRoute
  '/stammdaten/kontakte/neu': typeof StammdatenKontakteNeuRoute
  '/stammdaten/laender/$countryId': typeof StammdatenLaenderCountryIdRoute
  '/stammdaten/laender/neu': typeof StammdatenLaenderNeuRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId': typeof StammdatenNebenbestimmungenCollateralClauseIdRoute
  '/stammdaten/nebenbestimmungen/neu': typeof StammdatenNebenbestimmungenNeuRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId': typeof StammdatenVerfuegungsvorlagenLogTemplateIdRoute
  '/stammdaten/verfuegungsvorlagen/neu': typeof StammdatenVerfuegungsvorlagenNeuRoute
  '/verwaltung/benutzer/$userId': typeof VerwaltungBenutzerUserIdRoute
  '/verwaltung/benutzer/neu': typeof VerwaltungBenutzerNeuRoute
  '/verwaltung/gruppen/$groupId': typeof VerwaltungGruppenGroupIdRoute
  '/verwaltung/gruppen/neu': typeof VerwaltungGruppenNeuRoute
  '/vorgaenge/$dossierId/bearbeiten': typeof VorgaengeDossierIdBearbeitenRoute
  '/vorgaenge/alle': typeof VorgaengelistenAlleRoute
  '/vorgaenge/meine': typeof VorgaengelistenMeineRoute
  '/vorgaenge/unsere': typeof VorgaengelistenUnsereRoute
  '/auswahlfelder/abschlussarten': typeof AuswahlfelderAbschlussartenIndexRoute
  '/auswahlfelder/antragsarten-genehmigungstypen': typeof AuswahlfelderAntragsartenGenehmigungstypenIndexRoute
  '/auswahlfelder/antragsarten': typeof AuswahlfelderAntragsartenIndexRoute
  '/auswahlfelder/beantragte-verfahren': typeof AuswahlfelderBeantragteVerfahrenIndexRoute
  '/auswahlfelder/besondere-bedingungen': typeof AuswahlfelderBesondereBedingungenIndexRoute
  '/auswahlfelder/besondere-genehmigungen': typeof AuswahlfelderBesondereGenehmigungenIndexRoute
  '/auswahlfelder/branchen': typeof AuswahlfelderBranchenIndexRoute
  '/auswahlfelder/datumstypen': typeof AuswahlfelderDatumstypenIndexRoute
  '/auswahlfelder/entscheidungsebenen': typeof AuswahlfelderEntscheidungsebenenIndexRoute
  '/auswahlfelder/genehmigungstatbestaende': typeof AuswahlfelderGenehmigungstatbestaendeIndexRoute
  '/auswahlfelder/geschaeftsarten': typeof AuswahlfelderGeschaeftsartenIndexRoute
  '/auswahlfelder/haeufigkeiten-transport': typeof AuswahlfelderHaeufigkeitenTransportIndexRoute
  '/auswahlfelder/haeufigkeiten': typeof AuswahlfelderHaeufigkeitenIndexRoute
  '/auswahlfelder/import-export-arten': typeof AuswahlfelderImportExportArtenIndexRoute
  '/auswahlfelder/kassenzeichen': typeof AuswahlfelderKassenzeichenIndexRoute
  '/auswahlfelder/kategorien-gebuehren': typeof AuswahlfelderKategorienGebuehrenIndexRoute
  '/auswahlfelder/kategorien-nebenbestimmungen': typeof AuswahlfelderKategorienNebenbestimmungenIndexRoute
  '/auswahlfelder/kennzeichentypen': typeof AuswahlfelderKennzeichentypenIndexRoute
  '/auswahlfelder/laendergruppen-vorgang': typeof AuswahlfelderLaendergruppenVorgangIndexRoute
  '/auswahlfelder/laendergruppen': typeof AuswahlfelderLaendergruppenIndexRoute
  '/auswahlfelder/prioritaeten': typeof AuswahlfelderPrioritaetenIndexRoute
  '/auswahlfelder/pruefprogramme': typeof AuswahlfelderPruefprogrammeIndexRoute
  '/auswahlfelder/rechtsgrundlagen': typeof AuswahlfelderRechtsgrundlagenIndexRoute
  '/auswahlfelder/rollen-beteiligte': typeof AuswahlfelderRollenBeteiligteIndexRoute
  '/auswahlfelder/rollen': typeof AuswahlfelderRollenIndexRoute
  '/auswahlfelder/sonstige-antraege': typeof AuswahlfelderSonstigeAntraegeIndexRoute
  '/auswahlfelder/status': typeof AuswahlfelderStatusIndexRoute
  '/auswahlfelder/transportmittel': typeof AuswahlfelderTransportmittelIndexRoute
  '/auswahlfelder/transportrouten-vorgang': typeof AuswahlfelderTransportroutenVorgangIndexRoute
  '/auswahlfelder/transportrouten': typeof AuswahlfelderTransportroutenIndexRoute
  '/auswahlfelder/unterstatus': typeof AuswahlfelderUnterstatusIndexRoute
  '/auswahlfelder/vorgangsarten': typeof AuswahlfelderVorgangsartenIndexRoute
  '/auswahlfelder/votanten': typeof AuswahlfelderVotantenIndexRoute
  '/auswahlfelder/voten': typeof AuswahlfelderVotenIndexRoute
  '/auswahlfelder/waehrungen-ware': typeof AuswahlfelderWaehrungenWareIndexRoute
  '/auswahlfelder/waehrungen': typeof AuswahlfelderWaehrungenIndexRoute
  '/auswahlfelder/warenlisten-vorgang': typeof AuswahlfelderWarenlistenVorgangIndexRoute
  '/auswahlfelder/warenlisten': typeof AuswahlfelderWarenlistenIndexRoute
  '/auswahlfelder/zusaetzliche-merkmale': typeof AuswahlfelderZusaetzlicheMerkmaleIndexRoute
  '/auswahlfelder/zustaendigkeiten': typeof AuswahlfelderZustaendigkeitenIndexRoute
  '/stammdaten/aktenzeichen': typeof StammdatenAktenzeichenIndexRoute
  '/stammdaten/firmen': typeof StammdatenFirmenIndexRoute
  '/stammdaten/gebuehren': typeof StammdatenGebuehrenIndexRoute
  '/stammdaten/gueter': typeof StammdatenGueterIndexRoute
  '/stammdaten/kontakte': typeof StammdatenKontakteIndexRoute
  '/stammdaten/laender': typeof StammdatenLaenderIndexRoute
  '/stammdaten/nebenbestimmungen': typeof StammdatenNebenbestimmungenIndexRoute
  '/stammdaten/verfuegungsvorlagen': typeof StammdatenVerfuegungsvorlagenIndexRoute
  '/stammdaten/vorlagen': typeof StammdatenVorlagenIndexRoute
  '/verwaltung/benutzer': typeof VerwaltungBenutzerIndexRoute
  '/verwaltung/gruppen': typeof VerwaltungGruppenIndexRoute
  '/verwaltung/migrationsfehler': typeof VerwaltungMigrationsfehlerIndexRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten': typeof AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute
  '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten': typeof StammdatenAktenzeichenFileNumberIdBearbeitenRoute
  '/stammdaten/firmen/$companyId/bearbeiten': typeof StammdatenFirmenCompanyIdBearbeitenRoute
  '/stammdaten/gebuehren/$feeId/bearbeiten': typeof StammdatenGebuehrenFeeIdBearbeitenRoute
  '/stammdaten/gueter/$goodId/bearbeiten': typeof StammdatenGueterGoodIdBearbeitenRoute
  '/stammdaten/kontakte/$contactId/bearbeiten': typeof StammdatenKontakteContactIdBearbeitenRoute
  '/stammdaten/laender/$countryId/bearbeiten': typeof StammdatenLaenderCountryIdBearbeitenRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten': typeof StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten': typeof StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute
  '/verwaltung/benutzer/$userId/bearbeiten': typeof VerwaltungBenutzerUserIdBearbeitenRoute
  '/verwaltung/gruppen/$groupId/bearbeiten': typeof VerwaltungGruppenGroupIdBearbeitenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auswahlfelder/$choiceId': typeof AuswahlfelderChoiceIdRoute
  '/auswahlfelder/neu': typeof AuswahlfelderNeuRoute
  '/vorgaenge/$dossierId': typeof VorgaengeDossierIdRoute
  '/vorgaenge/neu': typeof VorgaengeNeuRoute
  '/auswahlfelder/': typeof AuswahlfelderIndexRoute
  '/stammdaten/': typeof StammdatenIndexRoute
  '/auswahlfelder/$choiceId_/bearbeiten': typeof AuswahlfelderChoiceIdBearbeitenRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId': typeof AuswahlfelderKassenzeichenKassenzeichenIdRoute
  '/auswahlfelder/kassenzeichen/neu': typeof AuswahlfelderKassenzeichenNeuRoute
  '/stammdaten/aktenzeichen/$fileNumberId': typeof StammdatenAktenzeichenFileNumberIdRoute
  '/stammdaten/aktenzeichen/neu': typeof StammdatenAktenzeichenNeuRoute
  '/stammdaten/firmen/$companyId': typeof StammdatenFirmenCompanyIdRoute
  '/stammdaten/firmen/neu': typeof StammdatenFirmenNeuRoute
  '/stammdaten/gebuehren/$feeId': typeof StammdatenGebuehrenFeeIdRoute
  '/stammdaten/gebuehren/neu': typeof StammdatenGebuehrenNeuRoute
  '/stammdaten/gueter/$goodId': typeof StammdatenGueterGoodIdRoute
  '/stammdaten/gueter/neu': typeof StammdatenGueterNeuRoute
  '/stammdaten/kontakte/$contactId': typeof StammdatenKontakteContactIdRoute
  '/stammdaten/kontakte/neu': typeof StammdatenKontakteNeuRoute
  '/stammdaten/laender/$countryId': typeof StammdatenLaenderCountryIdRoute
  '/stammdaten/laender/neu': typeof StammdatenLaenderNeuRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId': typeof StammdatenNebenbestimmungenCollateralClauseIdRoute
  '/stammdaten/nebenbestimmungen/neu': typeof StammdatenNebenbestimmungenNeuRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId': typeof StammdatenVerfuegungsvorlagenLogTemplateIdRoute
  '/stammdaten/verfuegungsvorlagen/neu': typeof StammdatenVerfuegungsvorlagenNeuRoute
  '/verwaltung/benutzer/$userId': typeof VerwaltungBenutzerUserIdRoute
  '/verwaltung/benutzer/neu': typeof VerwaltungBenutzerNeuRoute
  '/verwaltung/gruppen/$groupId': typeof VerwaltungGruppenGroupIdRoute
  '/verwaltung/gruppen/neu': typeof VerwaltungGruppenNeuRoute
  '/vorgaenge/$dossierId_/bearbeiten': typeof VorgaengeDossierIdBearbeitenRoute
  '/vorgaenge/(listen)/alle': typeof VorgaengelistenAlleRoute
  '/vorgaenge/(listen)/meine': typeof VorgaengelistenMeineRoute
  '/vorgaenge/(listen)/unsere': typeof VorgaengelistenUnsereRoute
  '/auswahlfelder/abschlussarten/': typeof AuswahlfelderAbschlussartenIndexRoute
  '/auswahlfelder/antragsarten-genehmigungstypen/': typeof AuswahlfelderAntragsartenGenehmigungstypenIndexRoute
  '/auswahlfelder/antragsarten/': typeof AuswahlfelderAntragsartenIndexRoute
  '/auswahlfelder/beantragte-verfahren/': typeof AuswahlfelderBeantragteVerfahrenIndexRoute
  '/auswahlfelder/besondere-bedingungen/': typeof AuswahlfelderBesondereBedingungenIndexRoute
  '/auswahlfelder/besondere-genehmigungen/': typeof AuswahlfelderBesondereGenehmigungenIndexRoute
  '/auswahlfelder/branchen/': typeof AuswahlfelderBranchenIndexRoute
  '/auswahlfelder/datumstypen/': typeof AuswahlfelderDatumstypenIndexRoute
  '/auswahlfelder/entscheidungsebenen/': typeof AuswahlfelderEntscheidungsebenenIndexRoute
  '/auswahlfelder/genehmigungstatbestaende/': typeof AuswahlfelderGenehmigungstatbestaendeIndexRoute
  '/auswahlfelder/geschaeftsarten/': typeof AuswahlfelderGeschaeftsartenIndexRoute
  '/auswahlfelder/haeufigkeiten-transport/': typeof AuswahlfelderHaeufigkeitenTransportIndexRoute
  '/auswahlfelder/haeufigkeiten/': typeof AuswahlfelderHaeufigkeitenIndexRoute
  '/auswahlfelder/import-export-arten/': typeof AuswahlfelderImportExportArtenIndexRoute
  '/auswahlfelder/kassenzeichen/': typeof AuswahlfelderKassenzeichenIndexRoute
  '/auswahlfelder/kategorien-gebuehren/': typeof AuswahlfelderKategorienGebuehrenIndexRoute
  '/auswahlfelder/kategorien-nebenbestimmungen/': typeof AuswahlfelderKategorienNebenbestimmungenIndexRoute
  '/auswahlfelder/kennzeichentypen/': typeof AuswahlfelderKennzeichentypenIndexRoute
  '/auswahlfelder/laendergruppen-vorgang/': typeof AuswahlfelderLaendergruppenVorgangIndexRoute
  '/auswahlfelder/laendergruppen/': typeof AuswahlfelderLaendergruppenIndexRoute
  '/auswahlfelder/prioritaeten/': typeof AuswahlfelderPrioritaetenIndexRoute
  '/auswahlfelder/pruefprogramme/': typeof AuswahlfelderPruefprogrammeIndexRoute
  '/auswahlfelder/rechtsgrundlagen/': typeof AuswahlfelderRechtsgrundlagenIndexRoute
  '/auswahlfelder/rollen-beteiligte/': typeof AuswahlfelderRollenBeteiligteIndexRoute
  '/auswahlfelder/rollen/': typeof AuswahlfelderRollenIndexRoute
  '/auswahlfelder/sonstige-antraege/': typeof AuswahlfelderSonstigeAntraegeIndexRoute
  '/auswahlfelder/status/': typeof AuswahlfelderStatusIndexRoute
  '/auswahlfelder/transportmittel/': typeof AuswahlfelderTransportmittelIndexRoute
  '/auswahlfelder/transportrouten-vorgang/': typeof AuswahlfelderTransportroutenVorgangIndexRoute
  '/auswahlfelder/transportrouten/': typeof AuswahlfelderTransportroutenIndexRoute
  '/auswahlfelder/unterstatus/': typeof AuswahlfelderUnterstatusIndexRoute
  '/auswahlfelder/vorgangsarten/': typeof AuswahlfelderVorgangsartenIndexRoute
  '/auswahlfelder/votanten/': typeof AuswahlfelderVotantenIndexRoute
  '/auswahlfelder/voten/': typeof AuswahlfelderVotenIndexRoute
  '/auswahlfelder/waehrungen-ware/': typeof AuswahlfelderWaehrungenWareIndexRoute
  '/auswahlfelder/waehrungen/': typeof AuswahlfelderWaehrungenIndexRoute
  '/auswahlfelder/warenlisten-vorgang/': typeof AuswahlfelderWarenlistenVorgangIndexRoute
  '/auswahlfelder/warenlisten/': typeof AuswahlfelderWarenlistenIndexRoute
  '/auswahlfelder/zusaetzliche-merkmale/': typeof AuswahlfelderZusaetzlicheMerkmaleIndexRoute
  '/auswahlfelder/zustaendigkeiten/': typeof AuswahlfelderZustaendigkeitenIndexRoute
  '/stammdaten/aktenzeichen/': typeof StammdatenAktenzeichenIndexRoute
  '/stammdaten/firmen/': typeof StammdatenFirmenIndexRoute
  '/stammdaten/gebuehren/': typeof StammdatenGebuehrenIndexRoute
  '/stammdaten/gueter/': typeof StammdatenGueterIndexRoute
  '/stammdaten/kontakte/': typeof StammdatenKontakteIndexRoute
  '/stammdaten/laender/': typeof StammdatenLaenderIndexRoute
  '/stammdaten/nebenbestimmungen/': typeof StammdatenNebenbestimmungenIndexRoute
  '/stammdaten/verfuegungsvorlagen/': typeof StammdatenVerfuegungsvorlagenIndexRoute
  '/stammdaten/vorlagen/': typeof StammdatenVorlagenIndexRoute
  '/verwaltung/benutzer/': typeof VerwaltungBenutzerIndexRoute
  '/verwaltung/gruppen/': typeof VerwaltungGruppenIndexRoute
  '/verwaltung/migrationsfehler/': typeof VerwaltungMigrationsfehlerIndexRoute
  '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten': typeof AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute
  '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten': typeof StammdatenAktenzeichenFileNumberIdBearbeitenRoute
  '/stammdaten/firmen/$companyId_/bearbeiten': typeof StammdatenFirmenCompanyIdBearbeitenRoute
  '/stammdaten/gebuehren/$feeId_/bearbeiten': typeof StammdatenGebuehrenFeeIdBearbeitenRoute
  '/stammdaten/gueter/$goodId_/bearbeiten': typeof StammdatenGueterGoodIdBearbeitenRoute
  '/stammdaten/kontakte/$contactId_/bearbeiten': typeof StammdatenKontakteContactIdBearbeitenRoute
  '/stammdaten/laender/$countryId_/bearbeiten': typeof StammdatenLaenderCountryIdBearbeitenRoute
  '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten': typeof StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute
  '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten': typeof StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute
  '/verwaltung/benutzer/$userId_/bearbeiten': typeof VerwaltungBenutzerUserIdBearbeitenRoute
  '/verwaltung/gruppen/$groupId_/bearbeiten': typeof VerwaltungGruppenGroupIdBearbeitenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auswahlfelder/$choiceId'
    | '/auswahlfelder/neu'
    | '/vorgaenge/$dossierId'
    | '/vorgaenge/neu'
    | '/auswahlfelder/'
    | '/stammdaten/'
    | '/auswahlfelder/$choiceId/bearbeiten'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId'
    | '/auswahlfelder/kassenzeichen/neu'
    | '/stammdaten/aktenzeichen/$fileNumberId'
    | '/stammdaten/aktenzeichen/neu'
    | '/stammdaten/firmen/$companyId'
    | '/stammdaten/firmen/neu'
    | '/stammdaten/gebuehren/$feeId'
    | '/stammdaten/gebuehren/neu'
    | '/stammdaten/gueter/$goodId'
    | '/stammdaten/gueter/neu'
    | '/stammdaten/kontakte/$contactId'
    | '/stammdaten/kontakte/neu'
    | '/stammdaten/laender/$countryId'
    | '/stammdaten/laender/neu'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId'
    | '/stammdaten/nebenbestimmungen/neu'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId'
    | '/stammdaten/verfuegungsvorlagen/neu'
    | '/verwaltung/benutzer/$userId'
    | '/verwaltung/benutzer/neu'
    | '/verwaltung/gruppen/$groupId'
    | '/verwaltung/gruppen/neu'
    | '/vorgaenge/$dossierId/bearbeiten'
    | '/vorgaenge/alle'
    | '/vorgaenge/meine'
    | '/vorgaenge/unsere'
    | '/auswahlfelder/abschlussarten/'
    | '/auswahlfelder/antragsarten-genehmigungstypen/'
    | '/auswahlfelder/antragsarten/'
    | '/auswahlfelder/beantragte-verfahren/'
    | '/auswahlfelder/besondere-bedingungen/'
    | '/auswahlfelder/besondere-genehmigungen/'
    | '/auswahlfelder/branchen/'
    | '/auswahlfelder/datumstypen/'
    | '/auswahlfelder/entscheidungsebenen/'
    | '/auswahlfelder/genehmigungstatbestaende/'
    | '/auswahlfelder/geschaeftsarten/'
    | '/auswahlfelder/haeufigkeiten-transport/'
    | '/auswahlfelder/haeufigkeiten/'
    | '/auswahlfelder/import-export-arten/'
    | '/auswahlfelder/kassenzeichen/'
    | '/auswahlfelder/kategorien-gebuehren/'
    | '/auswahlfelder/kategorien-nebenbestimmungen/'
    | '/auswahlfelder/kennzeichentypen/'
    | '/auswahlfelder/laendergruppen-vorgang/'
    | '/auswahlfelder/laendergruppen/'
    | '/auswahlfelder/prioritaeten/'
    | '/auswahlfelder/pruefprogramme/'
    | '/auswahlfelder/rechtsgrundlagen/'
    | '/auswahlfelder/rollen-beteiligte/'
    | '/auswahlfelder/rollen/'
    | '/auswahlfelder/sonstige-antraege/'
    | '/auswahlfelder/status/'
    | '/auswahlfelder/transportmittel/'
    | '/auswahlfelder/transportrouten-vorgang/'
    | '/auswahlfelder/transportrouten/'
    | '/auswahlfelder/unterstatus/'
    | '/auswahlfelder/vorgangsarten/'
    | '/auswahlfelder/votanten/'
    | '/auswahlfelder/voten/'
    | '/auswahlfelder/waehrungen-ware/'
    | '/auswahlfelder/waehrungen/'
    | '/auswahlfelder/warenlisten-vorgang/'
    | '/auswahlfelder/warenlisten/'
    | '/auswahlfelder/zusaetzliche-merkmale/'
    | '/auswahlfelder/zustaendigkeiten/'
    | '/stammdaten/aktenzeichen/'
    | '/stammdaten/firmen/'
    | '/stammdaten/gebuehren/'
    | '/stammdaten/gueter/'
    | '/stammdaten/kontakte/'
    | '/stammdaten/laender/'
    | '/stammdaten/nebenbestimmungen/'
    | '/stammdaten/verfuegungsvorlagen/'
    | '/stammdaten/vorlagen/'
    | '/verwaltung/benutzer/'
    | '/verwaltung/gruppen/'
    | '/verwaltung/migrationsfehler/'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten'
    | '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten'
    | '/stammdaten/firmen/$companyId/bearbeiten'
    | '/stammdaten/gebuehren/$feeId/bearbeiten'
    | '/stammdaten/gueter/$goodId/bearbeiten'
    | '/stammdaten/kontakte/$contactId/bearbeiten'
    | '/stammdaten/laender/$countryId/bearbeiten'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten'
    | '/verwaltung/benutzer/$userId/bearbeiten'
    | '/verwaltung/gruppen/$groupId/bearbeiten'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auswahlfelder/$choiceId'
    | '/auswahlfelder/neu'
    | '/vorgaenge/$dossierId'
    | '/vorgaenge/neu'
    | '/auswahlfelder'
    | '/stammdaten'
    | '/auswahlfelder/$choiceId/bearbeiten'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId'
    | '/auswahlfelder/kassenzeichen/neu'
    | '/stammdaten/aktenzeichen/$fileNumberId'
    | '/stammdaten/aktenzeichen/neu'
    | '/stammdaten/firmen/$companyId'
    | '/stammdaten/firmen/neu'
    | '/stammdaten/gebuehren/$feeId'
    | '/stammdaten/gebuehren/neu'
    | '/stammdaten/gueter/$goodId'
    | '/stammdaten/gueter/neu'
    | '/stammdaten/kontakte/$contactId'
    | '/stammdaten/kontakte/neu'
    | '/stammdaten/laender/$countryId'
    | '/stammdaten/laender/neu'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId'
    | '/stammdaten/nebenbestimmungen/neu'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId'
    | '/stammdaten/verfuegungsvorlagen/neu'
    | '/verwaltung/benutzer/$userId'
    | '/verwaltung/benutzer/neu'
    | '/verwaltung/gruppen/$groupId'
    | '/verwaltung/gruppen/neu'
    | '/vorgaenge/$dossierId/bearbeiten'
    | '/vorgaenge/alle'
    | '/vorgaenge/meine'
    | '/vorgaenge/unsere'
    | '/auswahlfelder/abschlussarten'
    | '/auswahlfelder/antragsarten-genehmigungstypen'
    | '/auswahlfelder/antragsarten'
    | '/auswahlfelder/beantragte-verfahren'
    | '/auswahlfelder/besondere-bedingungen'
    | '/auswahlfelder/besondere-genehmigungen'
    | '/auswahlfelder/branchen'
    | '/auswahlfelder/datumstypen'
    | '/auswahlfelder/entscheidungsebenen'
    | '/auswahlfelder/genehmigungstatbestaende'
    | '/auswahlfelder/geschaeftsarten'
    | '/auswahlfelder/haeufigkeiten-transport'
    | '/auswahlfelder/haeufigkeiten'
    | '/auswahlfelder/import-export-arten'
    | '/auswahlfelder/kassenzeichen'
    | '/auswahlfelder/kategorien-gebuehren'
    | '/auswahlfelder/kategorien-nebenbestimmungen'
    | '/auswahlfelder/kennzeichentypen'
    | '/auswahlfelder/laendergruppen-vorgang'
    | '/auswahlfelder/laendergruppen'
    | '/auswahlfelder/prioritaeten'
    | '/auswahlfelder/pruefprogramme'
    | '/auswahlfelder/rechtsgrundlagen'
    | '/auswahlfelder/rollen-beteiligte'
    | '/auswahlfelder/rollen'
    | '/auswahlfelder/sonstige-antraege'
    | '/auswahlfelder/status'
    | '/auswahlfelder/transportmittel'
    | '/auswahlfelder/transportrouten-vorgang'
    | '/auswahlfelder/transportrouten'
    | '/auswahlfelder/unterstatus'
    | '/auswahlfelder/vorgangsarten'
    | '/auswahlfelder/votanten'
    | '/auswahlfelder/voten'
    | '/auswahlfelder/waehrungen-ware'
    | '/auswahlfelder/waehrungen'
    | '/auswahlfelder/warenlisten-vorgang'
    | '/auswahlfelder/warenlisten'
    | '/auswahlfelder/zusaetzliche-merkmale'
    | '/auswahlfelder/zustaendigkeiten'
    | '/stammdaten/aktenzeichen'
    | '/stammdaten/firmen'
    | '/stammdaten/gebuehren'
    | '/stammdaten/gueter'
    | '/stammdaten/kontakte'
    | '/stammdaten/laender'
    | '/stammdaten/nebenbestimmungen'
    | '/stammdaten/verfuegungsvorlagen'
    | '/stammdaten/vorlagen'
    | '/verwaltung/benutzer'
    | '/verwaltung/gruppen'
    | '/verwaltung/migrationsfehler'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten'
    | '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten'
    | '/stammdaten/firmen/$companyId/bearbeiten'
    | '/stammdaten/gebuehren/$feeId/bearbeiten'
    | '/stammdaten/gueter/$goodId/bearbeiten'
    | '/stammdaten/kontakte/$contactId/bearbeiten'
    | '/stammdaten/laender/$countryId/bearbeiten'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten'
    | '/verwaltung/benutzer/$userId/bearbeiten'
    | '/verwaltung/gruppen/$groupId/bearbeiten'
  id:
    | '__root__'
    | '/'
    | '/auswahlfelder/$choiceId'
    | '/auswahlfelder/neu'
    | '/vorgaenge/$dossierId'
    | '/vorgaenge/neu'
    | '/auswahlfelder/'
    | '/stammdaten/'
    | '/auswahlfelder/$choiceId_/bearbeiten'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId'
    | '/auswahlfelder/kassenzeichen/neu'
    | '/stammdaten/aktenzeichen/$fileNumberId'
    | '/stammdaten/aktenzeichen/neu'
    | '/stammdaten/firmen/$companyId'
    | '/stammdaten/firmen/neu'
    | '/stammdaten/gebuehren/$feeId'
    | '/stammdaten/gebuehren/neu'
    | '/stammdaten/gueter/$goodId'
    | '/stammdaten/gueter/neu'
    | '/stammdaten/kontakte/$contactId'
    | '/stammdaten/kontakte/neu'
    | '/stammdaten/laender/$countryId'
    | '/stammdaten/laender/neu'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId'
    | '/stammdaten/nebenbestimmungen/neu'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId'
    | '/stammdaten/verfuegungsvorlagen/neu'
    | '/verwaltung/benutzer/$userId'
    | '/verwaltung/benutzer/neu'
    | '/verwaltung/gruppen/$groupId'
    | '/verwaltung/gruppen/neu'
    | '/vorgaenge/$dossierId_/bearbeiten'
    | '/vorgaenge/(listen)/alle'
    | '/vorgaenge/(listen)/meine'
    | '/vorgaenge/(listen)/unsere'
    | '/auswahlfelder/abschlussarten/'
    | '/auswahlfelder/antragsarten-genehmigungstypen/'
    | '/auswahlfelder/antragsarten/'
    | '/auswahlfelder/beantragte-verfahren/'
    | '/auswahlfelder/besondere-bedingungen/'
    | '/auswahlfelder/besondere-genehmigungen/'
    | '/auswahlfelder/branchen/'
    | '/auswahlfelder/datumstypen/'
    | '/auswahlfelder/entscheidungsebenen/'
    | '/auswahlfelder/genehmigungstatbestaende/'
    | '/auswahlfelder/geschaeftsarten/'
    | '/auswahlfelder/haeufigkeiten-transport/'
    | '/auswahlfelder/haeufigkeiten/'
    | '/auswahlfelder/import-export-arten/'
    | '/auswahlfelder/kassenzeichen/'
    | '/auswahlfelder/kategorien-gebuehren/'
    | '/auswahlfelder/kategorien-nebenbestimmungen/'
    | '/auswahlfelder/kennzeichentypen/'
    | '/auswahlfelder/laendergruppen-vorgang/'
    | '/auswahlfelder/laendergruppen/'
    | '/auswahlfelder/prioritaeten/'
    | '/auswahlfelder/pruefprogramme/'
    | '/auswahlfelder/rechtsgrundlagen/'
    | '/auswahlfelder/rollen-beteiligte/'
    | '/auswahlfelder/rollen/'
    | '/auswahlfelder/sonstige-antraege/'
    | '/auswahlfelder/status/'
    | '/auswahlfelder/transportmittel/'
    | '/auswahlfelder/transportrouten-vorgang/'
    | '/auswahlfelder/transportrouten/'
    | '/auswahlfelder/unterstatus/'
    | '/auswahlfelder/vorgangsarten/'
    | '/auswahlfelder/votanten/'
    | '/auswahlfelder/voten/'
    | '/auswahlfelder/waehrungen-ware/'
    | '/auswahlfelder/waehrungen/'
    | '/auswahlfelder/warenlisten-vorgang/'
    | '/auswahlfelder/warenlisten/'
    | '/auswahlfelder/zusaetzliche-merkmale/'
    | '/auswahlfelder/zustaendigkeiten/'
    | '/stammdaten/aktenzeichen/'
    | '/stammdaten/firmen/'
    | '/stammdaten/gebuehren/'
    | '/stammdaten/gueter/'
    | '/stammdaten/kontakte/'
    | '/stammdaten/laender/'
    | '/stammdaten/nebenbestimmungen/'
    | '/stammdaten/verfuegungsvorlagen/'
    | '/stammdaten/vorlagen/'
    | '/verwaltung/benutzer/'
    | '/verwaltung/gruppen/'
    | '/verwaltung/migrationsfehler/'
    | '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten'
    | '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten'
    | '/stammdaten/firmen/$companyId_/bearbeiten'
    | '/stammdaten/gebuehren/$feeId_/bearbeiten'
    | '/stammdaten/gueter/$goodId_/bearbeiten'
    | '/stammdaten/kontakte/$contactId_/bearbeiten'
    | '/stammdaten/laender/$countryId_/bearbeiten'
    | '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten'
    | '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten'
    | '/verwaltung/benutzer/$userId_/bearbeiten'
    | '/verwaltung/gruppen/$groupId_/bearbeiten'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuswahlfelderChoiceIdRoute: typeof AuswahlfelderChoiceIdRoute
  AuswahlfelderNeuRoute: typeof AuswahlfelderNeuRoute
  VorgaengeDossierIdRoute: typeof VorgaengeDossierIdRoute
  VorgaengeNeuRoute: typeof VorgaengeNeuRoute
  AuswahlfelderIndexRoute: typeof AuswahlfelderIndexRoute
  StammdatenIndexRoute: typeof StammdatenIndexRoute
  AuswahlfelderChoiceIdBearbeitenRoute: typeof AuswahlfelderChoiceIdBearbeitenRoute
  AuswahlfelderKassenzeichenKassenzeichenIdRoute: typeof AuswahlfelderKassenzeichenKassenzeichenIdRoute
  AuswahlfelderKassenzeichenNeuRoute: typeof AuswahlfelderKassenzeichenNeuRoute
  StammdatenAktenzeichenFileNumberIdRoute: typeof StammdatenAktenzeichenFileNumberIdRoute
  StammdatenAktenzeichenNeuRoute: typeof StammdatenAktenzeichenNeuRoute
  StammdatenFirmenCompanyIdRoute: typeof StammdatenFirmenCompanyIdRoute
  StammdatenFirmenNeuRoute: typeof StammdatenFirmenNeuRoute
  StammdatenGebuehrenFeeIdRoute: typeof StammdatenGebuehrenFeeIdRoute
  StammdatenGebuehrenNeuRoute: typeof StammdatenGebuehrenNeuRoute
  StammdatenGueterGoodIdRoute: typeof StammdatenGueterGoodIdRoute
  StammdatenGueterNeuRoute: typeof StammdatenGueterNeuRoute
  StammdatenKontakteContactIdRoute: typeof StammdatenKontakteContactIdRoute
  StammdatenKontakteNeuRoute: typeof StammdatenKontakteNeuRoute
  StammdatenLaenderCountryIdRoute: typeof StammdatenLaenderCountryIdRoute
  StammdatenLaenderNeuRoute: typeof StammdatenLaenderNeuRoute
  StammdatenNebenbestimmungenCollateralClauseIdRoute: typeof StammdatenNebenbestimmungenCollateralClauseIdRoute
  StammdatenNebenbestimmungenNeuRoute: typeof StammdatenNebenbestimmungenNeuRoute
  StammdatenVerfuegungsvorlagenLogTemplateIdRoute: typeof StammdatenVerfuegungsvorlagenLogTemplateIdRoute
  StammdatenVerfuegungsvorlagenNeuRoute: typeof StammdatenVerfuegungsvorlagenNeuRoute
  VerwaltungBenutzerUserIdRoute: typeof VerwaltungBenutzerUserIdRoute
  VerwaltungBenutzerNeuRoute: typeof VerwaltungBenutzerNeuRoute
  VerwaltungGruppenGroupIdRoute: typeof VerwaltungGruppenGroupIdRoute
  VerwaltungGruppenNeuRoute: typeof VerwaltungGruppenNeuRoute
  VorgaengeDossierIdBearbeitenRoute: typeof VorgaengeDossierIdBearbeitenRoute
  VorgaengelistenAlleRoute: typeof VorgaengelistenAlleRoute
  VorgaengelistenMeineRoute: typeof VorgaengelistenMeineRoute
  VorgaengelistenUnsereRoute: typeof VorgaengelistenUnsereRoute
  AuswahlfelderAbschlussartenIndexRoute: typeof AuswahlfelderAbschlussartenIndexRoute
  AuswahlfelderAntragsartenGenehmigungstypenIndexRoute: typeof AuswahlfelderAntragsartenGenehmigungstypenIndexRoute
  AuswahlfelderAntragsartenIndexRoute: typeof AuswahlfelderAntragsartenIndexRoute
  AuswahlfelderBeantragteVerfahrenIndexRoute: typeof AuswahlfelderBeantragteVerfahrenIndexRoute
  AuswahlfelderBesondereBedingungenIndexRoute: typeof AuswahlfelderBesondereBedingungenIndexRoute
  AuswahlfelderBesondereGenehmigungenIndexRoute: typeof AuswahlfelderBesondereGenehmigungenIndexRoute
  AuswahlfelderBranchenIndexRoute: typeof AuswahlfelderBranchenIndexRoute
  AuswahlfelderDatumstypenIndexRoute: typeof AuswahlfelderDatumstypenIndexRoute
  AuswahlfelderEntscheidungsebenenIndexRoute: typeof AuswahlfelderEntscheidungsebenenIndexRoute
  AuswahlfelderGenehmigungstatbestaendeIndexRoute: typeof AuswahlfelderGenehmigungstatbestaendeIndexRoute
  AuswahlfelderGeschaeftsartenIndexRoute: typeof AuswahlfelderGeschaeftsartenIndexRoute
  AuswahlfelderHaeufigkeitenTransportIndexRoute: typeof AuswahlfelderHaeufigkeitenTransportIndexRoute
  AuswahlfelderHaeufigkeitenIndexRoute: typeof AuswahlfelderHaeufigkeitenIndexRoute
  AuswahlfelderImportExportArtenIndexRoute: typeof AuswahlfelderImportExportArtenIndexRoute
  AuswahlfelderKassenzeichenIndexRoute: typeof AuswahlfelderKassenzeichenIndexRoute
  AuswahlfelderKategorienGebuehrenIndexRoute: typeof AuswahlfelderKategorienGebuehrenIndexRoute
  AuswahlfelderKategorienNebenbestimmungenIndexRoute: typeof AuswahlfelderKategorienNebenbestimmungenIndexRoute
  AuswahlfelderKennzeichentypenIndexRoute: typeof AuswahlfelderKennzeichentypenIndexRoute
  AuswahlfelderLaendergruppenVorgangIndexRoute: typeof AuswahlfelderLaendergruppenVorgangIndexRoute
  AuswahlfelderLaendergruppenIndexRoute: typeof AuswahlfelderLaendergruppenIndexRoute
  AuswahlfelderPrioritaetenIndexRoute: typeof AuswahlfelderPrioritaetenIndexRoute
  AuswahlfelderPruefprogrammeIndexRoute: typeof AuswahlfelderPruefprogrammeIndexRoute
  AuswahlfelderRechtsgrundlagenIndexRoute: typeof AuswahlfelderRechtsgrundlagenIndexRoute
  AuswahlfelderRollenBeteiligteIndexRoute: typeof AuswahlfelderRollenBeteiligteIndexRoute
  AuswahlfelderRollenIndexRoute: typeof AuswahlfelderRollenIndexRoute
  AuswahlfelderSonstigeAntraegeIndexRoute: typeof AuswahlfelderSonstigeAntraegeIndexRoute
  AuswahlfelderStatusIndexRoute: typeof AuswahlfelderStatusIndexRoute
  AuswahlfelderTransportmittelIndexRoute: typeof AuswahlfelderTransportmittelIndexRoute
  AuswahlfelderTransportroutenVorgangIndexRoute: typeof AuswahlfelderTransportroutenVorgangIndexRoute
  AuswahlfelderTransportroutenIndexRoute: typeof AuswahlfelderTransportroutenIndexRoute
  AuswahlfelderUnterstatusIndexRoute: typeof AuswahlfelderUnterstatusIndexRoute
  AuswahlfelderVorgangsartenIndexRoute: typeof AuswahlfelderVorgangsartenIndexRoute
  AuswahlfelderVotantenIndexRoute: typeof AuswahlfelderVotantenIndexRoute
  AuswahlfelderVotenIndexRoute: typeof AuswahlfelderVotenIndexRoute
  AuswahlfelderWaehrungenWareIndexRoute: typeof AuswahlfelderWaehrungenWareIndexRoute
  AuswahlfelderWaehrungenIndexRoute: typeof AuswahlfelderWaehrungenIndexRoute
  AuswahlfelderWarenlistenVorgangIndexRoute: typeof AuswahlfelderWarenlistenVorgangIndexRoute
  AuswahlfelderWarenlistenIndexRoute: typeof AuswahlfelderWarenlistenIndexRoute
  AuswahlfelderZusaetzlicheMerkmaleIndexRoute: typeof AuswahlfelderZusaetzlicheMerkmaleIndexRoute
  AuswahlfelderZustaendigkeitenIndexRoute: typeof AuswahlfelderZustaendigkeitenIndexRoute
  StammdatenAktenzeichenIndexRoute: typeof StammdatenAktenzeichenIndexRoute
  StammdatenFirmenIndexRoute: typeof StammdatenFirmenIndexRoute
  StammdatenGebuehrenIndexRoute: typeof StammdatenGebuehrenIndexRoute
  StammdatenGueterIndexRoute: typeof StammdatenGueterIndexRoute
  StammdatenKontakteIndexRoute: typeof StammdatenKontakteIndexRoute
  StammdatenLaenderIndexRoute: typeof StammdatenLaenderIndexRoute
  StammdatenNebenbestimmungenIndexRoute: typeof StammdatenNebenbestimmungenIndexRoute
  StammdatenVerfuegungsvorlagenIndexRoute: typeof StammdatenVerfuegungsvorlagenIndexRoute
  StammdatenVorlagenIndexRoute: typeof StammdatenVorlagenIndexRoute
  VerwaltungBenutzerIndexRoute: typeof VerwaltungBenutzerIndexRoute
  VerwaltungGruppenIndexRoute: typeof VerwaltungGruppenIndexRoute
  VerwaltungMigrationsfehlerIndexRoute: typeof VerwaltungMigrationsfehlerIndexRoute
  AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute: typeof AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute
  StammdatenAktenzeichenFileNumberIdBearbeitenRoute: typeof StammdatenAktenzeichenFileNumberIdBearbeitenRoute
  StammdatenFirmenCompanyIdBearbeitenRoute: typeof StammdatenFirmenCompanyIdBearbeitenRoute
  StammdatenGebuehrenFeeIdBearbeitenRoute: typeof StammdatenGebuehrenFeeIdBearbeitenRoute
  StammdatenGueterGoodIdBearbeitenRoute: typeof StammdatenGueterGoodIdBearbeitenRoute
  StammdatenKontakteContactIdBearbeitenRoute: typeof StammdatenKontakteContactIdBearbeitenRoute
  StammdatenLaenderCountryIdBearbeitenRoute: typeof StammdatenLaenderCountryIdBearbeitenRoute
  StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute: typeof StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute
  StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute: typeof StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute
  VerwaltungBenutzerUserIdBearbeitenRoute: typeof VerwaltungBenutzerUserIdBearbeitenRoute
  VerwaltungGruppenGroupIdBearbeitenRoute: typeof VerwaltungGruppenGroupIdBearbeitenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/': {
      id: '/stammdaten/'
      path: '/stammdaten'
      fullPath: '/stammdaten/'
      preLoaderRoute: typeof StammdatenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/': {
      id: '/auswahlfelder/'
      path: '/auswahlfelder'
      fullPath: '/auswahlfelder/'
      preLoaderRoute: typeof AuswahlfelderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/neu': {
      id: '/vorgaenge/neu'
      path: '/vorgaenge/neu'
      fullPath: '/vorgaenge/neu'
      preLoaderRoute: typeof VorgaengeNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/$dossierId': {
      id: '/vorgaenge/$dossierId'
      path: '/vorgaenge/$dossierId'
      fullPath: '/vorgaenge/$dossierId'
      preLoaderRoute: typeof VorgaengeDossierIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/neu': {
      id: '/auswahlfelder/neu'
      path: '/auswahlfelder/neu'
      fullPath: '/auswahlfelder/neu'
      preLoaderRoute: typeof AuswahlfelderNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/$choiceId': {
      id: '/auswahlfelder/$choiceId'
      path: '/auswahlfelder/$choiceId'
      fullPath: '/auswahlfelder/$choiceId'
      preLoaderRoute: typeof AuswahlfelderChoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/migrationsfehler/': {
      id: '/verwaltung/migrationsfehler/'
      path: '/verwaltung/migrationsfehler'
      fullPath: '/verwaltung/migrationsfehler/'
      preLoaderRoute: typeof VerwaltungMigrationsfehlerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/gruppen/': {
      id: '/verwaltung/gruppen/'
      path: '/verwaltung/gruppen'
      fullPath: '/verwaltung/gruppen/'
      preLoaderRoute: typeof VerwaltungGruppenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/benutzer/': {
      id: '/verwaltung/benutzer/'
      path: '/verwaltung/benutzer'
      fullPath: '/verwaltung/benutzer/'
      preLoaderRoute: typeof VerwaltungBenutzerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/vorlagen/': {
      id: '/stammdaten/vorlagen/'
      path: '/stammdaten/vorlagen'
      fullPath: '/stammdaten/vorlagen/'
      preLoaderRoute: typeof StammdatenVorlagenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/verfuegungsvorlagen/': {
      id: '/stammdaten/verfuegungsvorlagen/'
      path: '/stammdaten/verfuegungsvorlagen'
      fullPath: '/stammdaten/verfuegungsvorlagen/'
      preLoaderRoute: typeof StammdatenVerfuegungsvorlagenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/nebenbestimmungen/': {
      id: '/stammdaten/nebenbestimmungen/'
      path: '/stammdaten/nebenbestimmungen'
      fullPath: '/stammdaten/nebenbestimmungen/'
      preLoaderRoute: typeof StammdatenNebenbestimmungenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/laender/': {
      id: '/stammdaten/laender/'
      path: '/stammdaten/laender'
      fullPath: '/stammdaten/laender/'
      preLoaderRoute: typeof StammdatenLaenderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/kontakte/': {
      id: '/stammdaten/kontakte/'
      path: '/stammdaten/kontakte'
      fullPath: '/stammdaten/kontakte/'
      preLoaderRoute: typeof StammdatenKontakteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gueter/': {
      id: '/stammdaten/gueter/'
      path: '/stammdaten/gueter'
      fullPath: '/stammdaten/gueter/'
      preLoaderRoute: typeof StammdatenGueterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gebuehren/': {
      id: '/stammdaten/gebuehren/'
      path: '/stammdaten/gebuehren'
      fullPath: '/stammdaten/gebuehren/'
      preLoaderRoute: typeof StammdatenGebuehrenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/firmen/': {
      id: '/stammdaten/firmen/'
      path: '/stammdaten/firmen'
      fullPath: '/stammdaten/firmen/'
      preLoaderRoute: typeof StammdatenFirmenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/aktenzeichen/': {
      id: '/stammdaten/aktenzeichen/'
      path: '/stammdaten/aktenzeichen'
      fullPath: '/stammdaten/aktenzeichen/'
      preLoaderRoute: typeof StammdatenAktenzeichenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/zustaendigkeiten/': {
      id: '/auswahlfelder/zustaendigkeiten/'
      path: '/auswahlfelder/zustaendigkeiten'
      fullPath: '/auswahlfelder/zustaendigkeiten/'
      preLoaderRoute: typeof AuswahlfelderZustaendigkeitenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/zusaetzliche-merkmale/': {
      id: '/auswahlfelder/zusaetzliche-merkmale/'
      path: '/auswahlfelder/zusaetzliche-merkmale'
      fullPath: '/auswahlfelder/zusaetzliche-merkmale/'
      preLoaderRoute: typeof AuswahlfelderZusaetzlicheMerkmaleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/warenlisten/': {
      id: '/auswahlfelder/warenlisten/'
      path: '/auswahlfelder/warenlisten'
      fullPath: '/auswahlfelder/warenlisten/'
      preLoaderRoute: typeof AuswahlfelderWarenlistenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/warenlisten-vorgang/': {
      id: '/auswahlfelder/warenlisten-vorgang/'
      path: '/auswahlfelder/warenlisten-vorgang'
      fullPath: '/auswahlfelder/warenlisten-vorgang/'
      preLoaderRoute: typeof AuswahlfelderWarenlistenVorgangIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/waehrungen/': {
      id: '/auswahlfelder/waehrungen/'
      path: '/auswahlfelder/waehrungen'
      fullPath: '/auswahlfelder/waehrungen/'
      preLoaderRoute: typeof AuswahlfelderWaehrungenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/waehrungen-ware/': {
      id: '/auswahlfelder/waehrungen-ware/'
      path: '/auswahlfelder/waehrungen-ware'
      fullPath: '/auswahlfelder/waehrungen-ware/'
      preLoaderRoute: typeof AuswahlfelderWaehrungenWareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/voten/': {
      id: '/auswahlfelder/voten/'
      path: '/auswahlfelder/voten'
      fullPath: '/auswahlfelder/voten/'
      preLoaderRoute: typeof AuswahlfelderVotenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/votanten/': {
      id: '/auswahlfelder/votanten/'
      path: '/auswahlfelder/votanten'
      fullPath: '/auswahlfelder/votanten/'
      preLoaderRoute: typeof AuswahlfelderVotantenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/vorgangsarten/': {
      id: '/auswahlfelder/vorgangsarten/'
      path: '/auswahlfelder/vorgangsarten'
      fullPath: '/auswahlfelder/vorgangsarten/'
      preLoaderRoute: typeof AuswahlfelderVorgangsartenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/unterstatus/': {
      id: '/auswahlfelder/unterstatus/'
      path: '/auswahlfelder/unterstatus'
      fullPath: '/auswahlfelder/unterstatus/'
      preLoaderRoute: typeof AuswahlfelderUnterstatusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/transportrouten/': {
      id: '/auswahlfelder/transportrouten/'
      path: '/auswahlfelder/transportrouten'
      fullPath: '/auswahlfelder/transportrouten/'
      preLoaderRoute: typeof AuswahlfelderTransportroutenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/transportrouten-vorgang/': {
      id: '/auswahlfelder/transportrouten-vorgang/'
      path: '/auswahlfelder/transportrouten-vorgang'
      fullPath: '/auswahlfelder/transportrouten-vorgang/'
      preLoaderRoute: typeof AuswahlfelderTransportroutenVorgangIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/transportmittel/': {
      id: '/auswahlfelder/transportmittel/'
      path: '/auswahlfelder/transportmittel'
      fullPath: '/auswahlfelder/transportmittel/'
      preLoaderRoute: typeof AuswahlfelderTransportmittelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/status/': {
      id: '/auswahlfelder/status/'
      path: '/auswahlfelder/status'
      fullPath: '/auswahlfelder/status/'
      preLoaderRoute: typeof AuswahlfelderStatusIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/sonstige-antraege/': {
      id: '/auswahlfelder/sonstige-antraege/'
      path: '/auswahlfelder/sonstige-antraege'
      fullPath: '/auswahlfelder/sonstige-antraege/'
      preLoaderRoute: typeof AuswahlfelderSonstigeAntraegeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/rollen/': {
      id: '/auswahlfelder/rollen/'
      path: '/auswahlfelder/rollen'
      fullPath: '/auswahlfelder/rollen/'
      preLoaderRoute: typeof AuswahlfelderRollenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/rollen-beteiligte/': {
      id: '/auswahlfelder/rollen-beteiligte/'
      path: '/auswahlfelder/rollen-beteiligte'
      fullPath: '/auswahlfelder/rollen-beteiligte/'
      preLoaderRoute: typeof AuswahlfelderRollenBeteiligteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/rechtsgrundlagen/': {
      id: '/auswahlfelder/rechtsgrundlagen/'
      path: '/auswahlfelder/rechtsgrundlagen'
      fullPath: '/auswahlfelder/rechtsgrundlagen/'
      preLoaderRoute: typeof AuswahlfelderRechtsgrundlagenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/pruefprogramme/': {
      id: '/auswahlfelder/pruefprogramme/'
      path: '/auswahlfelder/pruefprogramme'
      fullPath: '/auswahlfelder/pruefprogramme/'
      preLoaderRoute: typeof AuswahlfelderPruefprogrammeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/prioritaeten/': {
      id: '/auswahlfelder/prioritaeten/'
      path: '/auswahlfelder/prioritaeten'
      fullPath: '/auswahlfelder/prioritaeten/'
      preLoaderRoute: typeof AuswahlfelderPrioritaetenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/laendergruppen/': {
      id: '/auswahlfelder/laendergruppen/'
      path: '/auswahlfelder/laendergruppen'
      fullPath: '/auswahlfelder/laendergruppen/'
      preLoaderRoute: typeof AuswahlfelderLaendergruppenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/laendergruppen-vorgang/': {
      id: '/auswahlfelder/laendergruppen-vorgang/'
      path: '/auswahlfelder/laendergruppen-vorgang'
      fullPath: '/auswahlfelder/laendergruppen-vorgang/'
      preLoaderRoute: typeof AuswahlfelderLaendergruppenVorgangIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kennzeichentypen/': {
      id: '/auswahlfelder/kennzeichentypen/'
      path: '/auswahlfelder/kennzeichentypen'
      fullPath: '/auswahlfelder/kennzeichentypen/'
      preLoaderRoute: typeof AuswahlfelderKennzeichentypenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kategorien-nebenbestimmungen/': {
      id: '/auswahlfelder/kategorien-nebenbestimmungen/'
      path: '/auswahlfelder/kategorien-nebenbestimmungen'
      fullPath: '/auswahlfelder/kategorien-nebenbestimmungen/'
      preLoaderRoute: typeof AuswahlfelderKategorienNebenbestimmungenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kategorien-gebuehren/': {
      id: '/auswahlfelder/kategorien-gebuehren/'
      path: '/auswahlfelder/kategorien-gebuehren'
      fullPath: '/auswahlfelder/kategorien-gebuehren/'
      preLoaderRoute: typeof AuswahlfelderKategorienGebuehrenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kassenzeichen/': {
      id: '/auswahlfelder/kassenzeichen/'
      path: '/auswahlfelder/kassenzeichen'
      fullPath: '/auswahlfelder/kassenzeichen/'
      preLoaderRoute: typeof AuswahlfelderKassenzeichenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/import-export-arten/': {
      id: '/auswahlfelder/import-export-arten/'
      path: '/auswahlfelder/import-export-arten'
      fullPath: '/auswahlfelder/import-export-arten/'
      preLoaderRoute: typeof AuswahlfelderImportExportArtenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/haeufigkeiten/': {
      id: '/auswahlfelder/haeufigkeiten/'
      path: '/auswahlfelder/haeufigkeiten'
      fullPath: '/auswahlfelder/haeufigkeiten/'
      preLoaderRoute: typeof AuswahlfelderHaeufigkeitenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/haeufigkeiten-transport/': {
      id: '/auswahlfelder/haeufigkeiten-transport/'
      path: '/auswahlfelder/haeufigkeiten-transport'
      fullPath: '/auswahlfelder/haeufigkeiten-transport/'
      preLoaderRoute: typeof AuswahlfelderHaeufigkeitenTransportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/geschaeftsarten/': {
      id: '/auswahlfelder/geschaeftsarten/'
      path: '/auswahlfelder/geschaeftsarten'
      fullPath: '/auswahlfelder/geschaeftsarten/'
      preLoaderRoute: typeof AuswahlfelderGeschaeftsartenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/genehmigungstatbestaende/': {
      id: '/auswahlfelder/genehmigungstatbestaende/'
      path: '/auswahlfelder/genehmigungstatbestaende'
      fullPath: '/auswahlfelder/genehmigungstatbestaende/'
      preLoaderRoute: typeof AuswahlfelderGenehmigungstatbestaendeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/entscheidungsebenen/': {
      id: '/auswahlfelder/entscheidungsebenen/'
      path: '/auswahlfelder/entscheidungsebenen'
      fullPath: '/auswahlfelder/entscheidungsebenen/'
      preLoaderRoute: typeof AuswahlfelderEntscheidungsebenenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/datumstypen/': {
      id: '/auswahlfelder/datumstypen/'
      path: '/auswahlfelder/datumstypen'
      fullPath: '/auswahlfelder/datumstypen/'
      preLoaderRoute: typeof AuswahlfelderDatumstypenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/branchen/': {
      id: '/auswahlfelder/branchen/'
      path: '/auswahlfelder/branchen'
      fullPath: '/auswahlfelder/branchen/'
      preLoaderRoute: typeof AuswahlfelderBranchenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/besondere-genehmigungen/': {
      id: '/auswahlfelder/besondere-genehmigungen/'
      path: '/auswahlfelder/besondere-genehmigungen'
      fullPath: '/auswahlfelder/besondere-genehmigungen/'
      preLoaderRoute: typeof AuswahlfelderBesondereGenehmigungenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/besondere-bedingungen/': {
      id: '/auswahlfelder/besondere-bedingungen/'
      path: '/auswahlfelder/besondere-bedingungen'
      fullPath: '/auswahlfelder/besondere-bedingungen/'
      preLoaderRoute: typeof AuswahlfelderBesondereBedingungenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/beantragte-verfahren/': {
      id: '/auswahlfelder/beantragte-verfahren/'
      path: '/auswahlfelder/beantragte-verfahren'
      fullPath: '/auswahlfelder/beantragte-verfahren/'
      preLoaderRoute: typeof AuswahlfelderBeantragteVerfahrenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/antragsarten/': {
      id: '/auswahlfelder/antragsarten/'
      path: '/auswahlfelder/antragsarten'
      fullPath: '/auswahlfelder/antragsarten/'
      preLoaderRoute: typeof AuswahlfelderAntragsartenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/antragsarten-genehmigungstypen/': {
      id: '/auswahlfelder/antragsarten-genehmigungstypen/'
      path: '/auswahlfelder/antragsarten-genehmigungstypen'
      fullPath: '/auswahlfelder/antragsarten-genehmigungstypen/'
      preLoaderRoute: typeof AuswahlfelderAntragsartenGenehmigungstypenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/abschlussarten/': {
      id: '/auswahlfelder/abschlussarten/'
      path: '/auswahlfelder/abschlussarten'
      fullPath: '/auswahlfelder/abschlussarten/'
      preLoaderRoute: typeof AuswahlfelderAbschlussartenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/(listen)/unsere': {
      id: '/vorgaenge/(listen)/unsere'
      path: '/vorgaenge/unsere'
      fullPath: '/vorgaenge/unsere'
      preLoaderRoute: typeof VorgaengelistenUnsereRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/(listen)/meine': {
      id: '/vorgaenge/(listen)/meine'
      path: '/vorgaenge/meine'
      fullPath: '/vorgaenge/meine'
      preLoaderRoute: typeof VorgaengelistenMeineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/(listen)/alle': {
      id: '/vorgaenge/(listen)/alle'
      path: '/vorgaenge/alle'
      fullPath: '/vorgaenge/alle'
      preLoaderRoute: typeof VorgaengelistenAlleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vorgaenge/$dossierId_/bearbeiten': {
      id: '/vorgaenge/$dossierId_/bearbeiten'
      path: '/vorgaenge/$dossierId/bearbeiten'
      fullPath: '/vorgaenge/$dossierId/bearbeiten'
      preLoaderRoute: typeof VorgaengeDossierIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/gruppen/neu': {
      id: '/verwaltung/gruppen/neu'
      path: '/verwaltung/gruppen/neu'
      fullPath: '/verwaltung/gruppen/neu'
      preLoaderRoute: typeof VerwaltungGruppenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/gruppen/$groupId': {
      id: '/verwaltung/gruppen/$groupId'
      path: '/verwaltung/gruppen/$groupId'
      fullPath: '/verwaltung/gruppen/$groupId'
      preLoaderRoute: typeof VerwaltungGruppenGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/benutzer/neu': {
      id: '/verwaltung/benutzer/neu'
      path: '/verwaltung/benutzer/neu'
      fullPath: '/verwaltung/benutzer/neu'
      preLoaderRoute: typeof VerwaltungBenutzerNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/benutzer/$userId': {
      id: '/verwaltung/benutzer/$userId'
      path: '/verwaltung/benutzer/$userId'
      fullPath: '/verwaltung/benutzer/$userId'
      preLoaderRoute: typeof VerwaltungBenutzerUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/verfuegungsvorlagen/neu': {
      id: '/stammdaten/verfuegungsvorlagen/neu'
      path: '/stammdaten/verfuegungsvorlagen/neu'
      fullPath: '/stammdaten/verfuegungsvorlagen/neu'
      preLoaderRoute: typeof StammdatenVerfuegungsvorlagenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/verfuegungsvorlagen/$logTemplateId': {
      id: '/stammdaten/verfuegungsvorlagen/$logTemplateId'
      path: '/stammdaten/verfuegungsvorlagen/$logTemplateId'
      fullPath: '/stammdaten/verfuegungsvorlagen/$logTemplateId'
      preLoaderRoute: typeof StammdatenVerfuegungsvorlagenLogTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/nebenbestimmungen/neu': {
      id: '/stammdaten/nebenbestimmungen/neu'
      path: '/stammdaten/nebenbestimmungen/neu'
      fullPath: '/stammdaten/nebenbestimmungen/neu'
      preLoaderRoute: typeof StammdatenNebenbestimmungenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/nebenbestimmungen/$collateralClauseId': {
      id: '/stammdaten/nebenbestimmungen/$collateralClauseId'
      path: '/stammdaten/nebenbestimmungen/$collateralClauseId'
      fullPath: '/stammdaten/nebenbestimmungen/$collateralClauseId'
      preLoaderRoute: typeof StammdatenNebenbestimmungenCollateralClauseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/laender/neu': {
      id: '/stammdaten/laender/neu'
      path: '/stammdaten/laender/neu'
      fullPath: '/stammdaten/laender/neu'
      preLoaderRoute: typeof StammdatenLaenderNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/laender/$countryId': {
      id: '/stammdaten/laender/$countryId'
      path: '/stammdaten/laender/$countryId'
      fullPath: '/stammdaten/laender/$countryId'
      preLoaderRoute: typeof StammdatenLaenderCountryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/kontakte/neu': {
      id: '/stammdaten/kontakte/neu'
      path: '/stammdaten/kontakte/neu'
      fullPath: '/stammdaten/kontakte/neu'
      preLoaderRoute: typeof StammdatenKontakteNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/kontakte/$contactId': {
      id: '/stammdaten/kontakte/$contactId'
      path: '/stammdaten/kontakte/$contactId'
      fullPath: '/stammdaten/kontakte/$contactId'
      preLoaderRoute: typeof StammdatenKontakteContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gueter/neu': {
      id: '/stammdaten/gueter/neu'
      path: '/stammdaten/gueter/neu'
      fullPath: '/stammdaten/gueter/neu'
      preLoaderRoute: typeof StammdatenGueterNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gueter/$goodId': {
      id: '/stammdaten/gueter/$goodId'
      path: '/stammdaten/gueter/$goodId'
      fullPath: '/stammdaten/gueter/$goodId'
      preLoaderRoute: typeof StammdatenGueterGoodIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gebuehren/neu': {
      id: '/stammdaten/gebuehren/neu'
      path: '/stammdaten/gebuehren/neu'
      fullPath: '/stammdaten/gebuehren/neu'
      preLoaderRoute: typeof StammdatenGebuehrenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gebuehren/$feeId': {
      id: '/stammdaten/gebuehren/$feeId'
      path: '/stammdaten/gebuehren/$feeId'
      fullPath: '/stammdaten/gebuehren/$feeId'
      preLoaderRoute: typeof StammdatenGebuehrenFeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/firmen/neu': {
      id: '/stammdaten/firmen/neu'
      path: '/stammdaten/firmen/neu'
      fullPath: '/stammdaten/firmen/neu'
      preLoaderRoute: typeof StammdatenFirmenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/firmen/$companyId': {
      id: '/stammdaten/firmen/$companyId'
      path: '/stammdaten/firmen/$companyId'
      fullPath: '/stammdaten/firmen/$companyId'
      preLoaderRoute: typeof StammdatenFirmenCompanyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/aktenzeichen/neu': {
      id: '/stammdaten/aktenzeichen/neu'
      path: '/stammdaten/aktenzeichen/neu'
      fullPath: '/stammdaten/aktenzeichen/neu'
      preLoaderRoute: typeof StammdatenAktenzeichenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/aktenzeichen/$fileNumberId': {
      id: '/stammdaten/aktenzeichen/$fileNumberId'
      path: '/stammdaten/aktenzeichen/$fileNumberId'
      fullPath: '/stammdaten/aktenzeichen/$fileNumberId'
      preLoaderRoute: typeof StammdatenAktenzeichenFileNumberIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kassenzeichen/neu': {
      id: '/auswahlfelder/kassenzeichen/neu'
      path: '/auswahlfelder/kassenzeichen/neu'
      fullPath: '/auswahlfelder/kassenzeichen/neu'
      preLoaderRoute: typeof AuswahlfelderKassenzeichenNeuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kassenzeichen/$kassenzeichenId': {
      id: '/auswahlfelder/kassenzeichen/$kassenzeichenId'
      path: '/auswahlfelder/kassenzeichen/$kassenzeichenId'
      fullPath: '/auswahlfelder/kassenzeichen/$kassenzeichenId'
      preLoaderRoute: typeof AuswahlfelderKassenzeichenKassenzeichenIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/$choiceId_/bearbeiten': {
      id: '/auswahlfelder/$choiceId_/bearbeiten'
      path: '/auswahlfelder/$choiceId/bearbeiten'
      fullPath: '/auswahlfelder/$choiceId/bearbeiten'
      preLoaderRoute: typeof AuswahlfelderChoiceIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/gruppen/$groupId_/bearbeiten': {
      id: '/verwaltung/gruppen/$groupId_/bearbeiten'
      path: '/verwaltung/gruppen/$groupId/bearbeiten'
      fullPath: '/verwaltung/gruppen/$groupId/bearbeiten'
      preLoaderRoute: typeof VerwaltungGruppenGroupIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verwaltung/benutzer/$userId_/bearbeiten': {
      id: '/verwaltung/benutzer/$userId_/bearbeiten'
      path: '/verwaltung/benutzer/$userId/bearbeiten'
      fullPath: '/verwaltung/benutzer/$userId/bearbeiten'
      preLoaderRoute: typeof VerwaltungBenutzerUserIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten': {
      id: '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten'
      path: '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten'
      fullPath: '/stammdaten/verfuegungsvorlagen/$logTemplateId/bearbeiten'
      preLoaderRoute: typeof StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten': {
      id: '/stammdaten/nebenbestimmungen/$collateralClauseId_/bearbeiten'
      path: '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten'
      fullPath: '/stammdaten/nebenbestimmungen/$collateralClauseId/bearbeiten'
      preLoaderRoute: typeof StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/laender/$countryId_/bearbeiten': {
      id: '/stammdaten/laender/$countryId_/bearbeiten'
      path: '/stammdaten/laender/$countryId/bearbeiten'
      fullPath: '/stammdaten/laender/$countryId/bearbeiten'
      preLoaderRoute: typeof StammdatenLaenderCountryIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/kontakte/$contactId_/bearbeiten': {
      id: '/stammdaten/kontakte/$contactId_/bearbeiten'
      path: '/stammdaten/kontakte/$contactId/bearbeiten'
      fullPath: '/stammdaten/kontakte/$contactId/bearbeiten'
      preLoaderRoute: typeof StammdatenKontakteContactIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gueter/$goodId_/bearbeiten': {
      id: '/stammdaten/gueter/$goodId_/bearbeiten'
      path: '/stammdaten/gueter/$goodId/bearbeiten'
      fullPath: '/stammdaten/gueter/$goodId/bearbeiten'
      preLoaderRoute: typeof StammdatenGueterGoodIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/gebuehren/$feeId_/bearbeiten': {
      id: '/stammdaten/gebuehren/$feeId_/bearbeiten'
      path: '/stammdaten/gebuehren/$feeId/bearbeiten'
      fullPath: '/stammdaten/gebuehren/$feeId/bearbeiten'
      preLoaderRoute: typeof StammdatenGebuehrenFeeIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/firmen/$companyId_/bearbeiten': {
      id: '/stammdaten/firmen/$companyId_/bearbeiten'
      path: '/stammdaten/firmen/$companyId/bearbeiten'
      fullPath: '/stammdaten/firmen/$companyId/bearbeiten'
      preLoaderRoute: typeof StammdatenFirmenCompanyIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten': {
      id: '/stammdaten/aktenzeichen/$fileNumberId_/bearbeiten'
      path: '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten'
      fullPath: '/stammdaten/aktenzeichen/$fileNumberId/bearbeiten'
      preLoaderRoute: typeof StammdatenAktenzeichenFileNumberIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten': {
      id: '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten'
      path: '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten'
      fullPath: '/auswahlfelder/kassenzeichen/$kassenzeichenId/bearbeiten'
      preLoaderRoute: typeof AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuswahlfelderChoiceIdRoute: AuswahlfelderChoiceIdRoute,
  AuswahlfelderNeuRoute: AuswahlfelderNeuRoute,
  VorgaengeDossierIdRoute: VorgaengeDossierIdRoute,
  VorgaengeNeuRoute: VorgaengeNeuRoute,
  AuswahlfelderIndexRoute: AuswahlfelderIndexRoute,
  StammdatenIndexRoute: StammdatenIndexRoute,
  AuswahlfelderChoiceIdBearbeitenRoute: AuswahlfelderChoiceIdBearbeitenRoute,
  AuswahlfelderKassenzeichenKassenzeichenIdRoute:
    AuswahlfelderKassenzeichenKassenzeichenIdRoute,
  AuswahlfelderKassenzeichenNeuRoute: AuswahlfelderKassenzeichenNeuRoute,
  StammdatenAktenzeichenFileNumberIdRoute:
    StammdatenAktenzeichenFileNumberIdRoute,
  StammdatenAktenzeichenNeuRoute: StammdatenAktenzeichenNeuRoute,
  StammdatenFirmenCompanyIdRoute: StammdatenFirmenCompanyIdRoute,
  StammdatenFirmenNeuRoute: StammdatenFirmenNeuRoute,
  StammdatenGebuehrenFeeIdRoute: StammdatenGebuehrenFeeIdRoute,
  StammdatenGebuehrenNeuRoute: StammdatenGebuehrenNeuRoute,
  StammdatenGueterGoodIdRoute: StammdatenGueterGoodIdRoute,
  StammdatenGueterNeuRoute: StammdatenGueterNeuRoute,
  StammdatenKontakteContactIdRoute: StammdatenKontakteContactIdRoute,
  StammdatenKontakteNeuRoute: StammdatenKontakteNeuRoute,
  StammdatenLaenderCountryIdRoute: StammdatenLaenderCountryIdRoute,
  StammdatenLaenderNeuRoute: StammdatenLaenderNeuRoute,
  StammdatenNebenbestimmungenCollateralClauseIdRoute:
    StammdatenNebenbestimmungenCollateralClauseIdRoute,
  StammdatenNebenbestimmungenNeuRoute: StammdatenNebenbestimmungenNeuRoute,
  StammdatenVerfuegungsvorlagenLogTemplateIdRoute:
    StammdatenVerfuegungsvorlagenLogTemplateIdRoute,
  StammdatenVerfuegungsvorlagenNeuRoute: StammdatenVerfuegungsvorlagenNeuRoute,
  VerwaltungBenutzerUserIdRoute: VerwaltungBenutzerUserIdRoute,
  VerwaltungBenutzerNeuRoute: VerwaltungBenutzerNeuRoute,
  VerwaltungGruppenGroupIdRoute: VerwaltungGruppenGroupIdRoute,
  VerwaltungGruppenNeuRoute: VerwaltungGruppenNeuRoute,
  VorgaengeDossierIdBearbeitenRoute: VorgaengeDossierIdBearbeitenRoute,
  VorgaengelistenAlleRoute: VorgaengelistenAlleRoute,
  VorgaengelistenMeineRoute: VorgaengelistenMeineRoute,
  VorgaengelistenUnsereRoute: VorgaengelistenUnsereRoute,
  AuswahlfelderAbschlussartenIndexRoute: AuswahlfelderAbschlussartenIndexRoute,
  AuswahlfelderAntragsartenGenehmigungstypenIndexRoute:
    AuswahlfelderAntragsartenGenehmigungstypenIndexRoute,
  AuswahlfelderAntragsartenIndexRoute: AuswahlfelderAntragsartenIndexRoute,
  AuswahlfelderBeantragteVerfahrenIndexRoute:
    AuswahlfelderBeantragteVerfahrenIndexRoute,
  AuswahlfelderBesondereBedingungenIndexRoute:
    AuswahlfelderBesondereBedingungenIndexRoute,
  AuswahlfelderBesondereGenehmigungenIndexRoute:
    AuswahlfelderBesondereGenehmigungenIndexRoute,
  AuswahlfelderBranchenIndexRoute: AuswahlfelderBranchenIndexRoute,
  AuswahlfelderDatumstypenIndexRoute: AuswahlfelderDatumstypenIndexRoute,
  AuswahlfelderEntscheidungsebenenIndexRoute:
    AuswahlfelderEntscheidungsebenenIndexRoute,
  AuswahlfelderGenehmigungstatbestaendeIndexRoute:
    AuswahlfelderGenehmigungstatbestaendeIndexRoute,
  AuswahlfelderGeschaeftsartenIndexRoute:
    AuswahlfelderGeschaeftsartenIndexRoute,
  AuswahlfelderHaeufigkeitenTransportIndexRoute:
    AuswahlfelderHaeufigkeitenTransportIndexRoute,
  AuswahlfelderHaeufigkeitenIndexRoute: AuswahlfelderHaeufigkeitenIndexRoute,
  AuswahlfelderImportExportArtenIndexRoute:
    AuswahlfelderImportExportArtenIndexRoute,
  AuswahlfelderKassenzeichenIndexRoute: AuswahlfelderKassenzeichenIndexRoute,
  AuswahlfelderKategorienGebuehrenIndexRoute:
    AuswahlfelderKategorienGebuehrenIndexRoute,
  AuswahlfelderKategorienNebenbestimmungenIndexRoute:
    AuswahlfelderKategorienNebenbestimmungenIndexRoute,
  AuswahlfelderKennzeichentypenIndexRoute:
    AuswahlfelderKennzeichentypenIndexRoute,
  AuswahlfelderLaendergruppenVorgangIndexRoute:
    AuswahlfelderLaendergruppenVorgangIndexRoute,
  AuswahlfelderLaendergruppenIndexRoute: AuswahlfelderLaendergruppenIndexRoute,
  AuswahlfelderPrioritaetenIndexRoute: AuswahlfelderPrioritaetenIndexRoute,
  AuswahlfelderPruefprogrammeIndexRoute: AuswahlfelderPruefprogrammeIndexRoute,
  AuswahlfelderRechtsgrundlagenIndexRoute:
    AuswahlfelderRechtsgrundlagenIndexRoute,
  AuswahlfelderRollenBeteiligteIndexRoute:
    AuswahlfelderRollenBeteiligteIndexRoute,
  AuswahlfelderRollenIndexRoute: AuswahlfelderRollenIndexRoute,
  AuswahlfelderSonstigeAntraegeIndexRoute:
    AuswahlfelderSonstigeAntraegeIndexRoute,
  AuswahlfelderStatusIndexRoute: AuswahlfelderStatusIndexRoute,
  AuswahlfelderTransportmittelIndexRoute:
    AuswahlfelderTransportmittelIndexRoute,
  AuswahlfelderTransportroutenVorgangIndexRoute:
    AuswahlfelderTransportroutenVorgangIndexRoute,
  AuswahlfelderTransportroutenIndexRoute:
    AuswahlfelderTransportroutenIndexRoute,
  AuswahlfelderUnterstatusIndexRoute: AuswahlfelderUnterstatusIndexRoute,
  AuswahlfelderVorgangsartenIndexRoute: AuswahlfelderVorgangsartenIndexRoute,
  AuswahlfelderVotantenIndexRoute: AuswahlfelderVotantenIndexRoute,
  AuswahlfelderVotenIndexRoute: AuswahlfelderVotenIndexRoute,
  AuswahlfelderWaehrungenWareIndexRoute: AuswahlfelderWaehrungenWareIndexRoute,
  AuswahlfelderWaehrungenIndexRoute: AuswahlfelderWaehrungenIndexRoute,
  AuswahlfelderWarenlistenVorgangIndexRoute:
    AuswahlfelderWarenlistenVorgangIndexRoute,
  AuswahlfelderWarenlistenIndexRoute: AuswahlfelderWarenlistenIndexRoute,
  AuswahlfelderZusaetzlicheMerkmaleIndexRoute:
    AuswahlfelderZusaetzlicheMerkmaleIndexRoute,
  AuswahlfelderZustaendigkeitenIndexRoute:
    AuswahlfelderZustaendigkeitenIndexRoute,
  StammdatenAktenzeichenIndexRoute: StammdatenAktenzeichenIndexRoute,
  StammdatenFirmenIndexRoute: StammdatenFirmenIndexRoute,
  StammdatenGebuehrenIndexRoute: StammdatenGebuehrenIndexRoute,
  StammdatenGueterIndexRoute: StammdatenGueterIndexRoute,
  StammdatenKontakteIndexRoute: StammdatenKontakteIndexRoute,
  StammdatenLaenderIndexRoute: StammdatenLaenderIndexRoute,
  StammdatenNebenbestimmungenIndexRoute: StammdatenNebenbestimmungenIndexRoute,
  StammdatenVerfuegungsvorlagenIndexRoute:
    StammdatenVerfuegungsvorlagenIndexRoute,
  StammdatenVorlagenIndexRoute: StammdatenVorlagenIndexRoute,
  VerwaltungBenutzerIndexRoute: VerwaltungBenutzerIndexRoute,
  VerwaltungGruppenIndexRoute: VerwaltungGruppenIndexRoute,
  VerwaltungMigrationsfehlerIndexRoute: VerwaltungMigrationsfehlerIndexRoute,
  AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute:
    AuswahlfelderKassenzeichenKassenzeichenIdBearbeitenRoute,
  StammdatenAktenzeichenFileNumberIdBearbeitenRoute:
    StammdatenAktenzeichenFileNumberIdBearbeitenRoute,
  StammdatenFirmenCompanyIdBearbeitenRoute:
    StammdatenFirmenCompanyIdBearbeitenRoute,
  StammdatenGebuehrenFeeIdBearbeitenRoute:
    StammdatenGebuehrenFeeIdBearbeitenRoute,
  StammdatenGueterGoodIdBearbeitenRoute: StammdatenGueterGoodIdBearbeitenRoute,
  StammdatenKontakteContactIdBearbeitenRoute:
    StammdatenKontakteContactIdBearbeitenRoute,
  StammdatenLaenderCountryIdBearbeitenRoute:
    StammdatenLaenderCountryIdBearbeitenRoute,
  StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute:
    StammdatenNebenbestimmungenCollateralClauseIdBearbeitenRoute,
  StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute:
    StammdatenVerfuegungsvorlagenLogTemplateIdBearbeitenRoute,
  VerwaltungBenutzerUserIdBearbeitenRoute:
    VerwaltungBenutzerUserIdBearbeitenRoute,
  VerwaltungGruppenGroupIdBearbeitenRoute:
    VerwaltungGruppenGroupIdBearbeitenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
